{
  "1_months": "monthly",
  "1_weeks": "weekly",
  "3_months": "3-month",
  "6_months": "6-month",
  "_privacy_policy_instrumental": "$t(privacy_policy)",
  "_privacy_policy_instrumental_period": "$t(privacy_policy).",
  "about_title": "About me",
  "account_label": "Account",
  "add": "Add",
  "add_avatar_verification_again_message": "For security reasons, when you add a new photo we'll send your account for verification again.",
  "add_photo": "Add photo",
  "alert_already_registered_title": "This user is already registered",
  "alert_login_confirm_code_blocked_message": "You've used all tries, please try again in {{minutes}}",
  "alert_login_confirm_code_incorrect_message_one": "You have {{count}} try left",
  "alert_login_confirm_code_incorrect_message_other": "You have {{count}} tries left",
  "alert_login_confirm_code_incorrect_title": "Your code is incorrect",
  "alert_login_spam_limit_message": "Try again in 10 seconds",
  "alert_login_spam_limit_title": "Whoa! Not so fast.",
  "alert_register_dob_low_message": "You need to be at least 18 to register.",
  "alert_register_dob_low_title": "It looks like you're under 18",
  "allow": "Allow",
  "ambassador_add_video_label": "Add video",
  "ambassador_agreement_label": "I have read and agree with both the policy and the agreement",
  "ambassador_approved_info_part_1": "As a reward you receive",
  "ambassador_approved_info_part_2": "free 1-month {{subscriptionName}} Subscription.",
  "ambassador_approved_subtitle": "Our team has processed the content you provided. We are sincerely grateful for the quality content and trust in our company.",
  "ambassador_approved_title": "Congratulations! You are a {{appName}} Ambassador!",
  "ambassador_aspect_ratio_spec_label": "Aspect ratio:",
  "ambassador_aspect_ratio_spec_value": "Portrait [9:16]",
  "ambassador_content_appear_item": "If selected, your content may appear in {{appName}}’s social channels or in ads.",
  "ambassador_content_appear_title": "Where will your content appear?",
  "ambassador_declined_subtitle": "Your content has been processed, but it doesn't meet our requirements. You can try again anytime through your Settings menu.",
  "ambassador_declined_title": "Thank you for your activity!",
  "ambassador_how_to_become_item1": "Record or upload a portrait video of yourself using one of the following prompts.",
  "ambassador_how_to_become_item2": "Follow the recording specs to make sure your video will qualify.",
  "ambassador_how_to_become_item3": "Upload and submit! If your video is approved, you’ll receive a free 1-month premium subscription immediately.",
  "ambassador_how_to_become_title": "Here’s how to become a {{appName}} Ambassador:",
  "ambassador_length_spec_label": "Length:",
  "ambassador_length_spec_value": "15 to 60 seconds",
  "ambassador_other_spec_label": "Other considerations:",
  "ambassador_other_spec_value": "lighting and sound quality are important. Please make sure your video is not dimly lit or poor quality. Also make sure that there is no background noise and that your voice is clear without echo in the video sound.",
  "ambassador_prompt_subtitle_part1": "Become a {{appName}} Ambassador to help us spread the word about {{appName}} and get a",
  "ambassador_prompt_subtitle_part2": "free 1-month {{subscriptionName}} Subscription",
  "ambassador_prompt_subtitle_part3": "(worth {{price}})",
  "ambassador_prompt_title": "Let’s grow together - be {{appName}} Ambassador",
  "ambassador_prompts_item1": "What’s wrong with dating apps today / why do you like {{appName}}?",
  "ambassador_prompts_item2": "What are your favorite features of the {{appName}} app? (people around the world, translator, verified profiles, etc.)",
  "ambassador_prompts_item3": "Freeform: come up with something funny or unique to you to hype {{appName}}!",
  "ambassador_prompts_title": "Prompts:",
  "ambassador_public_agreement": "Ambassador Public Agreement",
  "ambassador_specs_title": "Specs:",
  "ambassador_stay_until_download_label": "Stay on this screen until the download is complete.",
  "ambassador_submitted_subtitle": "Our team will process your content within 7 days. You will receive a notification about the results of participation in the competition.",
  "ambassador_submitted_title": "That's great! Thank you for your activity!",
  "ambassador_upload_error_label": "Error uploading video files. Please try again.",
  "ambassador_video_label": "Video {{index}}",
  "ambassador_video_preview_label": "Click on the image 👇 to view an example",
  "app_review_negative_cta": "Not really",
  "app_review_subtitle_new": "Your feedback helps us make {{appName}} better.",
  "app_review_title_new": "Are you enjoying {{appName}}?",
  "apply": "Apply",
  "audio_prompt_delete_title": "Delete this recording?",
  "audio_prompt_dialog_text": "Let people hear your personality",
  "audio_prompt_dialog_title": "Add a Voice Prompt",
  "audio_prompt_discard_recording": "Discard the recording?",
  "audio_prompt_interrupted_dialog_title": "Recording interrupted",
  "audio_prompt_mic_access_text": "To record a voice prompt, please allow microphone access in your device settings.",
  "audio_prompt_mic_access_title": "Microphone access required",
  "audio_prompt_record_failed_dialog_text": "Try recording again.",
  "audio_prompt_record_failed_dialog_title": "Recording failed",
  "audio_prompt_redo": "Redo recording",
  "audio_prompt_rule_ads": "Ads, promotions, or directing users off-platform",
  "audio_prompt_rule_ai": "Impersonating another person or using altered/AI-generated voice",
  "audio_prompt_rule_any": "Any inappropriate content involving minors",
  "audio_prompt_rule_explicit": "Sexually explicit or overly suggestive content",
  "audio_prompt_rule_hate": "Hate speech, harassment, or abusive language",
  "audio_prompt_rule_info": "Not allowed:",
  "audio_prompt_rule_music": "Music, singing copyrighted songs, or dominant background audio",
  "audio_prompt_rule_scam": "Scams, misleading statements, or requests for money",
  "audio_prompt_suggestion_cta": "Try it",
  "audio_prompt_suggestion_text": "Record your answer so people can hear your personality",
  "audio_prompt_too_short_text": "Record at least {{minDuration}}.",
  "audio_prompt_too_short_title": "Recording too short",
  "audio_prompt_validation_message": "Your recording didn’t meet our rules. Please try again.",
  "audio_prompt_validation_title": "Recording not allowed",
  "audio_prompts_1": "“Hello” in my language is",
  "audio_prompts_10": "If we traveled tomorrow, I’d take you to",
  "audio_prompts_11": "The kind of travel partner I am is",
  "audio_prompts_12": "The next country I want to visit is",
  "audio_prompts_13": "Something romantic in my language is",
  "audio_prompts_14": "A funny word in my language is",
  "audio_prompts_15": "The next language I want to learn is",
  "audio_prompts_16": "A word in my language that doesn’t translate well is",
  "audio_prompts_17": "“Home” to me means",
  "audio_prompts_18": "Something I’m passionate about is",
  "audio_prompts_19": "The moment that shaped me the most is",
  "audio_prompts_2": "One thing people misunderstand about my country is",
  "audio_prompts_20": "One thing I value in life is",
  "audio_prompts_21": "Something that always makes me happy is",
  "audio_prompts_22": "A great relationship to me looks like",
  "audio_prompts_23": "What makes someone attractive to me is",
  "audio_prompts_24": "One small thing that makes me feel loved is",
  "audio_prompts_25": "The partner I’m looking for now is",
  "audio_prompts_26": "My friends describe me in a relationship as",
  "audio_prompts_27": "My perfect first date is",
  "audio_prompts_28": "Something fun we should try together is",
  "audio_prompts_29": "A song that makes me want to dance is",
  "audio_prompts_3": "A tradition from my culture I’d share with a partner is",
  "audio_prompts_30": "Something that would make us laugh on a first date is",
  "audio_prompts_31": "Something surprising about me is",
  "audio_prompts_32": "My spontaneous adventure would be",
  "audio_prompts_33": "A dish from my country everyone should try is",
  "audio_prompts_34": "My favorite food is",
  "audio_prompts_35": "For someone I really like, I’d cook",
  "audio_prompts_36": "The best street food I’ve had is",
  "audio_prompts_37": "A meal that reminds me of home is",
  "audio_prompts_38": "Something I love doing in my free time is",
  "audio_prompts_39": "A new hobby I want to try is",
  "audio_prompts_4": "My hometown in 10 words is",
  "audio_prompts_40": "Something I could teach you is",
  "audio_prompts_41": "My ideal weekend activity is",
  "audio_prompts_5": "Something unique about where I grew up is",
  "audio_prompts_7": "The most beautiful place I’ve ever been is",
  "audio_prompts_8": "To understand my country, you should visit",
  "audio_prompts_9": "My most unforgettable travel moment is",
  "avatar_error_message": "The photo doesn't comply with our rules. Please try again.",
  "avatar_error_title": "Your photo is not allowed",
  "avatar_rule_duplicate": "Duplicate photos",
  "avatar_rule_no_face": "Photos where your face isn’t clearly visible",
  "avatar_rule_other_people": "Photos of other people, including celebrities",
  "avatar_rule_pornographic": "Pornographic photos",
  "avatar_rule_with_text": "Photos with text, QR codes, logos, watermarks, or obvious editing",
  "avatar_rules_info": "Be yourself and help keep the community safe.",
  "avatar_rules_list_title": "Not allowed in profile photos:",
  "avatar_rules_title": "Rules",
  "avatar_tip_clear_face_subtitle": "Make sure your face is clearly visible.",
  "avatar_tip_clear_face_title": "Clear photo of your face",
  "avatar_tip_interests_subtitle": "Share photos of your lifestyle, travels, or hobbies.",
  "avatar_tip_interests_title": "Show your interests",
  "avatar_tip_no_text_subtitle": "Avoid photos with text, numbers, or promotions.",
  "avatar_tip_no_text_title": "No text or promos",
  "avatar_tip_variety_subtitle": "Upload different photos to keep your profile interesting.",
  "avatar_tip_variety_title": "Show variety",
  "avatar_tip_yourself_only_subtitle": "Avoid adding friends or other people to your photos.",
  "avatar_tip_yourself_only_title": "Add photos of just you",
  "basics_title": "My basics",
  "block_and_report": "Block and Report",
  "boost_activation_no_permission_alert_message": "To activate $t(boosts_one), allow {{appName}} to access your geolocation.",
  "boost_activation_no_permission_alert_title": "Allow access to your geolocation",
  "boost_cancel_title": "Want to remove yourself from Map?",
  "boost_error_text": "Your $t(boosts_one) couldn’t be activated.",
  "boost_in_incognito_alert_message": "Activating $t(boosts_one) will turn off Incognito mode and make your profile visible to others.",
  "boost_in_incognito_alert_positive": "Activate $t(boosts_one)",
  "boost_in_incognito_alert_title": "Your Incognito mode is on",
  "boost_simple_activate_button": "Show me on Map",
  "boost_simple_activate_description": "Each time you come online, your profile will appear on the Map for 24 hours.",
  "boost_simple_activate_title": "Be seen on Map",
  "boost_simple_onboard_text": "Meet real people worldwide who were recently online",
  "boost_super_activate_button": "$t(boosts_one) me",
  "boost_super_activate_description": "$t(boosts_one) your profile for {{boostDuration}} to get 10x more $t(matches_other).",
  "boost_super_activate_title": "Get 10x more $t(matches_other)",
  "boost_super_in_progress_description": "We’re showing your profile to more people. Stay active - send $t(smashes_other) and $t(super_smashes_other) to find your $t(matches_one).",
  "boost_super_in_progress_stop": "Remove $t(boosts_one)",
  "boost_super_in_progress_title": "Your $t(boosts_one) is active!",
  "boost_super_onboard_text": "Users with $t(boosts_one) appear more prominently",
  "boosts_few": "$t(boosts_other)",
  "boosts_title": "$t(boosts_other)",
  "boosts_two": "$t(boosts_other)",
  "call_audio_call": "Audio call",
  "call_audio_missed": "Missed audio call",
  "call_control_camera": "Camera",
  "call_control_camera_flip": "Flip",
  "call_control_end": "End",
  "call_control_mute": "Mute",
  "call_control_speaker": "Speaker",
  "call_control_unmute": "Unmute",
  "call_incoming_action_accept": "Accept",
  "call_incoming_action_decline": "Decline",
  "call_missed_from": "From {{firstName}}",
  "call_permission_request": "Allow calls?",
  "call_rating_submit": "Submit",
  "call_rating_title": "How was the quality of the call?",
  "call_secured": "The call is encrypted",
  "call_status_calling": "Calling...",
  "call_status_canceled": "Canceled",
  "call_status_declined": "Declined",
  "call_status_error": "Failure",
  "call_status_finished": "Finished",
  "call_status_initializing": "Initializing call...",
  "call_status_ringing": "Ringing...",
  "call_status_user_busy": "User busy",
  "call_video_call": "Video call",
  "call_video_missed": "Missed video call",
  "calls_incoming_audio_call_label": "Incoming audio call",
  "calls_incoming_video_call_label": "Incoming video call",
  "calls_outcoming_audio_call_label": "Outgoing audio call",
  "calls_outcoming_video_call_label": "Outgoing video call",
  "cancel": "Cancel",
  "cards_no_users_cta": "Open Search filters",
  "cards_no_users_label": "That's all for now. Expand your search in Search filters to discover more people.",
  "change": "Change",
  "close": "Close",
  "close_chat_cta": "Close the chat",
  "close_the_chat": "Close the chat",
  "community_guidelines_learn_more": "Learn more about our",
  "community_guidelines_link": "Community guidelines",
  "community_guidelines_link_instrumental": "$t(community_guidelines_link)",
  "complete_profile": "Complete profile",
  "compliment": "Compliment",
  "compliment_cancel_alert_subtitle": "Your compliment won’t be sent, and the text will not be saved.",
  "compliment_cancel_alert_title": "Are you sure you want to close?",
  "compliment_from_label": "{{firstName}} sent you a compliment",
  "compliment_tip_cta": "Compliment",
  "compliment_tip_subtitle": "Send a compliment with a $t(super_smashes_one) to increase your chances of getting new $t(matches_other).",
  "confirm": "Confirm",
  "contact_to_support": "Contact customer support",
  "continue": "continue",
  "continue_sign_with_apple": "Continue with Apple",
  "continue_sign_with_email": "Continue with e-mail",
  "continue_sign_with_google": "Continue with Google",
  "continue_sign_with_phone": "Use phone number",
  "cookie_policy_link": "$t(footer_cookie_policy_title)",
  "country_label": "Country",
  "daysGenitive_one": "$t(days_one)",
  "daysGenitive_other": "$t(days_other)",
  "daysInstrumental_one": "$t(days_one)",
  "daysInstrumental_other": "$t(days_other)",
  "days_one": "day",
  "days_other": "days",
  "delete": "Delete",
  "delete_account_limit_reached_message": "You won’t be able to create a new account within 30 days if you delete this one.",
  "delete_account_limit_reached_title": "Keep in mind",
  "delete_my_account_back_to_app": "Continue using {{appName}}",
  "delete_my_account_feedback_cta": "Send and remove my account",
  "delete_my_account_reason_cant_find_match": "I can’t find a $t(matches_one)",
  "delete_my_account_reason_found_match": "I found a $t(matches_one)",
  "delete_my_account_reason_how_use_it": "I’m not sure how to use it",
  "delete_my_account_reason_register_again": "I want to register again",
  "delete_my_account_reason_technical_issue": "I have technical issue",
  "delete_my_account_reason_too_expensive": "It’s too expensive",
  "delete_my_account_subtitle": "Please tell us why you are deleting your account",
  "delete_my_account_title": "Are you sure you want to delete your account?",
  "delete_my_suspicious_alert_message": "This message will be permanently deleted from this chat.",
  "delete_prompt_confirmation": "Delete this prompt?",
  "delete_your_account_cta": "Delete your account",
  "delete_your_account_title": "Delete your account",
  "discard": "Discard",
  "discover_tab_label": "People",
  "done": "Done",
  "dont_view_cta": "Don’t view",
  "drinking_on_holidays": "On holidays",
  "edit": "Edit",
  "edit_age_low_alert_message": "{{appName}} is only available to people aged 18 and over.",
  "edit_age_low_alert_title": "You must be 18 or older",
  "edit_age_title": "Edit my age",
  "edit_gender_item_iam": "I'm...",
  "edit_gender_title": "Edit my gender",
  "edit_goal_title": "Edit my goal",
  "edit_interests_show_less": "Show less",
  "edit_interests_show_more": "Show more",
  "edit_more_about_me_picker_title_height": "Your height",
  "edit_more_about_me_picker_title_weight": "Your weight",
  "edit_more_about_me_title_drinking": "Do you drink?",
  "edit_more_about_me_title_education_level": "What is your education level?",
  "edit_more_about_me_title_exercise": "Do you do sports?",
  "edit_more_about_me_title_height": "What is your height?",
  "edit_more_about_me_title_kids": "Do you have kids?",
  "edit_more_about_me_title_marital_status": "What is your marital status?",
  "edit_more_about_me_title_pets": "Do you have pets?",
  "edit_more_about_me_title_religion": "Do you identify with a religion?",
  "edit_more_about_me_title_sex_orientation": "What is your sexual orientation?",
  "edit_more_about_me_title_smoking": "Do you smoke?",
  "edit_more_about_me_title_star_sign": "What is your star sign?",
  "edit_more_about_me_title_values": "What is the most important thing in life for you?",
  "edit_more_about_me_title_weight": "What is your weight?",
  "edit_name_first_name_placeholder": "Enter your first name",
  "edit_name_title": "Edit my name",
  "edit_once_confirmation": "Are you confirm to change your {{field}} from \"{{from}}\" to \"{{to}}\"? You will not able to do this again.",
  "edit_once_confirmation_field_age": "birthday",
  "edit_once_confirmation_field_gender": "gender",
  "edit_once_confirmation_field_name": "name",
  "edit_once_info": "Note: you can only change this once.",
  "edit_once_used": "You’ve already used this option.",
  "edit_profile_about_info": "Write a lively and engaging intro",
  "edit_profile_about_me_placeholder": "Tell something about yourself...",
  "edit_profile_audio_prompts_example": "Not sure what to say? Hear an example.",
  "edit_profile_audio_prompts_section": "Voice prompt",
  "edit_profile_audio_prompts_subtitle_placeholder": "And record your answer",
  "edit_profile_audio_prompts_tip": "Tap the mic button to start",
  "edit_profile_audio_redo_alert_text": "Your current recording will be deleted.",
  "edit_profile_audio_redo_alert_title": "Record again?",
  "edit_profile_basics_info": "Specify general information about yourself",
  "edit_profile_basics_label_age": "Age",
  "edit_profile_basics_label_gender": "Gender",
  "edit_profile_basics_label_name": "Name",
  "edit_profile_basics_label_school": "School",
  "edit_profile_basics_label_work": "Work",
  "edit_profile_best_avatar_info": "Photo Genius automatically finds and shows your best photos first, helping you make a great first impression.",
  "edit_profile_best_avatar_label": "Photo Genius",
  "edit_profile_best_avatar_section": "Photo options",
  "edit_profile_city_geo_alert_message": "To verify your location, allow {{appName}} to access your geolocation",
  "edit_profile_drag_and_drop_photo": "Drag and drop photos to change their order",
  "edit_profile_drag_and_drop_prompt": "Drag to reorder",
  "edit_profile_goal_info": "Tell others what you are looking for",
  "edit_profile_interests_info": "Tell others what you're into. This will help you find people with similar interests.",
  "edit_profile_more_info": "Specify more information about yourself to find suitable people",
  "edit_profile_more_label_drinking": "Drinking",
  "edit_profile_more_label_education_level": "Education level",
  "edit_profile_more_label_exercise": "Exercise",
  "edit_profile_more_label_height": "Height",
  "edit_profile_more_label_kids": "Kids",
  "edit_profile_more_label_marital_status": "Marital status",
  "edit_profile_more_label_religion": "Religion",
  "edit_profile_more_label_sex_orientation": "Sexual orientation",
  "edit_profile_more_label_smoking": "Smoking",
  "edit_profile_more_label_star_sign": "Star sign",
  "edit_profile_more_label_values": "Values",
  "edit_profile_more_label_weight": "Weight",
  "edit_profile_more_section": "More about me",
  "edit_profile_prompts_info": "Answer prompts to give a glimpse of what it’s like to date you",
  "edit_profile_prompts_section_new": "Written prompts",
  "edit_profile_title": "{{percents}}% complete",
  "edit_profile_verification_section": "Verification",
  "edit_prompt_answer_subtitle_placeholder": "And write your answer",
  "edit_prompt_answer_title": "Edit your answer",
  "edit_prompt_answer_title_placeholder": "Select a prompt",
  "edit_prompt_placeholder": "Write your answer here...",
  "edit_school_name_placeholder": "Institution",
  "edit_school_title": "Edit my education",
  "edit_school_year_placeholder": "Graduation year",
  "edit_work_company_placeholder": "Company name",
  "edit_work_role_placeholder": "Position",
  "edit_work_title": "Edit my work",
  "education_level_graduate_degree": "Graduate degree",
  "education_level_high_school": "High school",
  "education_level_in_college": "In college",
  "education_level_in_grad_school": "In grad school",
  "education_level_tech_school": "Tech school",
  "education_level_undergraduate_degree": "Undergraduate degree",
  "email_confirm_code_not_received": "Not received?",
  "email_confirm_code_resend": "We've sent a code to your email. You can get another one in {{seconds}} sec.",
  "email_confirm_code_send_again": "Send again",
  "email_confirm_code_title": "Enter confirmation code",
  "email_confirm_code_tries_prompt": "Repeat in {{minutes}}",
  "email_confirm_code_tries_title": "Your attempts are over",
  "email_request_code_invalid_email": "Your email address is incorrect",
  "email_request_code_subtitle": "To create or login to your account",
  "email_request_code_title": "Enter your email",
  "enable_notification_alert_message": "Get notified when someone likes or messages you.",
  "enable_notification_alert_negative_cta": "Not now",
  "enable_notification_alert_positive_cta": "Notify me",
  "enable_notification_alert_title": "Don't miss new $t(matches_other)",
  "enable_notification_title": "Enable notifications",
  "ethnicity_aboriginal_australian": "Aboriginal Australian",
  "ethnicity_acehnese": "Acehnese",
  "ethnicity_afghan": "Afghan",
  "ethnicity_ainu": "Ainu",
  "ethnicity_akan": "Akan",
  "ethnicity_albanian": "Albanian",
  "ethnicity_algerian": "Algerian",
  "ethnicity_amhara": "Amhara",
  "ethnicity_argentinian": "Argentinian",
  "ethnicity_armenian": "Armenian",
  "ethnicity_assamese": "Assamese",
  "ethnicity_australian": "Australian",
  "ethnicity_austrian": "Austrian",
  "ethnicity_azerbaijani": "Azerbaijani",
  "ethnicity_bahamian": "Bahamian",
  "ethnicity_balinese": "Balinese",
  "ethnicity_baloch": "Baloch",
  "ethnicity_bangladeshi": "Bangladeshi",
  "ethnicity_basque": "Basque",
  "ethnicity_batak": "Batak",
  "ethnicity_bavarian": "Bavarian",
  "ethnicity_belgian": "Belgian",
  "ethnicity_bengali": "Bengali",
  "ethnicity_berber": "Berber",
  "ethnicity_bisaya": "Bisaya",
  "ethnicity_brazilian": "Brazilian",
  "ethnicity_breton": "Breton",
  "ethnicity_buginese": "Buginese",
  "ethnicity_bulgarian": "Bulgarian",
  "ethnicity_burmese": "Burmese",
  "ethnicity_cameroonian": "Cameroonian",
  "ethnicity_caribbean": "Caribbean",
  "ethnicity_carolinian": "Carolinian",
  "ethnicity_catalonian": "Catalonian",
  "ethnicity_cebuano": "Cebuano",
  "ethnicity_chamorro": "Chamorro",
  "ethnicity_chilean": "Chilean",
  "ethnicity_colombian": "Colombian",
  "ethnicity_congolese": "Congolese",
  "ethnicity_corsican": "Corsican",
  "ethnicity_cuban": "Cuban",
  "ethnicity_czech": "Czech",
  "ethnicity_danish": "Danish",
  "ethnicity_dayak": "Dayak",
  "ethnicity_dutch": "Dutch",
  "ethnicity_ecuadorian": "Ecuadorian",
  "ethnicity_egyptian": "Egyptian",
  "ethnicity_ethiopian": "Ethiopian",
  "ethnicity_fijian": "Fijian",
  "ethnicity_filipino": "Filipino",
  "ethnicity_finnish": "Finnish",
  "ethnicity_french": "French",
  "ethnicity_fulani": "Fulani",
  "ethnicity_georgian": "Georgian",
  "ethnicity_german": "German",
  "ethnicity_ghanaian": "Ghanaian",
  "ethnicity_gikuyu": "Gikuyu",
  "ethnicity_greek": "Greek",
  "ethnicity_gujarati": "Gujarati",
  "ethnicity_han_chinese": "Han Chinese",
  "ethnicity_hausa": "Hausa",
  "ethnicity_hawaiian": "Hawaiian",
  "ethnicity_hmong": "Hmong",
  "ethnicity_hui": "Hui",
  "ethnicity_hungarian": "Hungarian",
  "ethnicity_igbo": "Igbo",
  "ethnicity_ilocano": "Ilocano",
  "ethnicity_indian": "Indian",
  "ethnicity_iranian": "Iranian",
  "ethnicity_iraqi": "Iraqi",
  "ethnicity_irish": "Irish",
  "ethnicity_italian": "Italian",
  "ethnicity_ivorian": "Ivorian",
  "ethnicity_japanese": "Japanese",
  "ethnicity_javanese": "Javanese",
  "ethnicity_jewish": "Jewish",
  "ethnicity_jola": "Jola",
  "ethnicity_jordanian": "Jordanian",
  "ethnicity_kalenjin": "Kalenjin",
  "ethnicity_kannada": "Kannada",
  "ethnicity_kazakh": "Kazakh",
  "ethnicity_kenyan": "Kenyan",
  "ethnicity_khmer": "Khmer",
  "ethnicity_korean": "Korean",
  "ethnicity_kurdish": "Kurdish",
  "ethnicity_kyrgyz": "Kyrgyz",
  "ethnicity_lao": "Lao",
  "ethnicity_lebanese": "Lebanese",
  "ethnicity_libyan": "Libyan",
  "ethnicity_lithuanian": "Lithuanian",
  "ethnicity_luo": "Luo",
  "ethnicity_macedonian": "Macedonian",
  "ethnicity_malagasy": "Malagasy",
  "ethnicity_malayali": "Malayali",
  "ethnicity_malaysian": "Malaysian",
  "ethnicity_malian": "Malian",
  "ethnicity_manchu": "Manchu",
  "ethnicity_mandinka": "Mandinka",
  "ethnicity_maori": "Maori",
  "ethnicity_marathi": "Marathi",
  "ethnicity_mexican": "Mexican",
  "ethnicity_miao": "Miao",
  "ethnicity_minangkabau": "Minangkabau",
  "ethnicity_mongolian": "Mongolian",
  "ethnicity_moro": "Moro",
  "ethnicity_moroccan": "Moroccan",
  "ethnicity_nepali": "Nepali",
  "ethnicity_new_zealander": "New Zealander",
  "ethnicity_nigerian": "Nigerian",
  "ethnicity_norwegian": "Norwegian",
  "ethnicity_odia": "Odia",
  "ethnicity_oromo": "Oromo",
  "ethnicity_palauan": "Palauan",
  "ethnicity_palestinian": "Palestinian",
  "ethnicity_papuan": "Papuan",
  "ethnicity_pashtun": "Pashtun",
  "ethnicity_peruvian": "Peruvian",
  "ethnicity_polish": "Polish",
  "ethnicity_portuguese": "Portuguese",
  "ethnicity_punjabi": "Punjabi",
  "ethnicity_romanian": "Romanian",
  "ethnicity_russian": "Russian",
  "ethnicity_ryukyuan": "Ryukyuan",
  "ethnicity_samoan": "Samoan",
  "ethnicity_sardinian": "Sardinian",
  "ethnicity_sasak": "Sasak",
  "ethnicity_saudi": "Saudi",
  "ethnicity_scots": "Scots",
  "ethnicity_senegalese": "Senegalese",
  "ethnicity_serbian": "Serbian",
  "ethnicity_sicilian": "Sicilian",
  "ethnicity_sindhi": "Sindhi",
  "ethnicity_singaporean": "Singaporean",
  "ethnicity_slovak": "Slovak",
  "ethnicity_somali": "Somali",
  "ethnicity_south_african": "South African",
  "ethnicity_spanish": "Spanish",
  "ethnicity_sri_lankan": "Sri Lankan",
  "ethnicity_sudanese": "Sudanese",
  "ethnicity_sundanese": "Sundanese",
  "ethnicity_swazi": "Swazi",
  "ethnicity_swedish": "Swedish",
  "ethnicity_swiss": "Swiss",
  "ethnicity_syrian": "Syrian",
  "ethnicity_taiwanese": "Taiwanese",
  "ethnicity_tajik": "Tajik",
  "ethnicity_tanzanian": "Tanzanian",
  "ethnicity_thai": "Thai",
  "ethnicity_tibetan": "Tibetan",
  "ethnicity_tigrinya": "Tigrinya",
  "ethnicity_tongan": "Tongan",
  "ethnicity_torres_strait_islander": "Torres Strait Islander",
  "ethnicity_tswana": "Tswana",
  "ethnicity_tunisian": "Tunisian",
  "ethnicity_turkish": "Turkish",
  "ethnicity_turkmen": "Turkmen",
  "ethnicity_ugandan": "Ugandan",
  "ethnicity_ukrainian": "Ukrainian",
  "ethnicity_uyghur": "Uyghur",
  "ethnicity_uzbek": "Uzbek",
  "ethnicity_venezuelan": "Venezuelan",
  "ethnicity_vietnamese": "Vietnamese",
  "ethnicity_welsh": "Welsh",
  "ethnicity_wolof": "Wolof",
  "ethnicity_yoruba": "Yoruba",
  "ethnicity_zhuang": "Zhuang",
  "ethnicity_zimbabwean": "Zimbabwean",
  "ethnicity_zulu": "Zulu",
  "exercise_lifestyle": "Lifestyle",
  "faq_how_contact_customer_support_answer": "If you have any issues or questions, write to us {{supportEmail}} and our customer support will help you.",
  "faq_how_contact_customer_support_question": "How to contact customer support?",
  "faq_how_pass_verification_answer": "The verification process is easy! First, make sure you have a photo on your profile that clearly shows your face. Next, open a screen for the verification. Replicate a pose shown in an example and make a selfie. Make sure a pose shown in an example matches your selfie. Send the selfie for verification.\nThe verification process may take some time.",
  "faq_how_pass_verification_question": "How to pass verification?",
  "faq_how_works_answer": "Map:\nOn Map, you can discover users around the world. Launch $t(boosts_one) to show your profile on Map to get more $t(matches_other).\n\nCards:\nOn Cards, you can swipe user profiles worldwide that are chosen for you.\n\n$t(smashes_one):\nSend $t(smashes_one) to user that you liked.\n\n$t(super_smashes_other):\nTo stand out and show a great liking – send $t(super_smashes_other).\n\nPass:\nIf you are not interested in a user, send Pass.\n\n$t(matches_one):\nAs soon as you've exchanged $t(smashes_one) or $t(super_smashes_one) with a user, you'll be allowed to chat with them.",
  "faq_how_works_question": "How {{appName}} works?",
  "faq_should_go_through_verification_answer": "Show people worldwide that you’re real. Get verified, and your profile will be more visible for users.",
  "faq_should_go_through_verification_question": "Why should I go through a verification?",
  "faq_title": "FAQ",
  "faq_when_can_chat_answer": "As soon as you exchange $t(smashes_one) or $t(super_smashes_one) with users, you'll be able to chat with them. Start send $t(smashes_other) to users.",
  "faq_when_can_chat_question": "When I can chat with users?",
  "faq_why_account_can_be_blocked_answer": "We want to make you able to make quality connections around the world safely. Therefore, any scam or harassment is not allowed. Be real.",
  "faq_why_account_can_be_blocked_question": "Why can my account be blocked?",
  "faq_why_buying_subscription_is_cool_answer": "With {{subscriptionName}} you can get quality new connections in the fastest way. You'll not spend your time finding out who visits your profile or sending $t(smashes_one) to you. All features will be unblocked to reach your goal - have quality connections in everyday life.",
  "faq_why_buying_subscription_is_cool_question": "Why buying {{subscriptionName}} is cool?",
  "faq_why_smashes_hidden_answer": "Hidden $t(smashes_other) is a secret way to boost your activity — send $t(smashes_other) to others and find out who sent $t(smashes_one) to you.\n\nSend $t(smashes_other) and uncover your secret admirers.",
  "faq_why_smashes_hidden_question": "Why are $t(smashes_other) sent to me hidden?",
  "favourites_header_description": "Upgrade to {{subscriptionName}} to see who favorited you",
  "favourites_header_description_subscribed": "They really liked you. Message them.",
  "favourites_header_title": "You were favorited",
  "favourites_onboarding_description": "Add users to your Favorites to help them stand out from the rest.",
  "favourites_onboarding_title": "Favorites",
  "favourites_screen_title": "They favorited you",
  "features_animHeader_offer_end": "Offer ends in ",
  "features_animHeader_offer_price": "Upgrade for ",
  "features_animHeader_reactions_description": "Upgrade to {{subscriptionName}} to see who liked you!",
  "features_animHeader_reactions_description_subscriber": "Take a look at these people who liked you!",
  "features_animHeader_reactions_offer": "Get {{discountPercent}}% off {{subscriptionName}}\nto see who liked you",
  "features_animHeader_sent": "$t(smashes_other) you sent",
  "features_animHeader_sent_description": "Upgrade to {{subscriptionName}} to send $t(super_smashes_other) and stand out!",
  "features_animHeader_sent_description_subscriber": "Send $t(super_smashes_other) to stand out and get more $t(matches_other)!",
  "features_animHeader_sent_offer": "Get {{discountPercent}}% off {{subscriptionName}} to send more $t(super_smashes_other)",
  "features_animHeader_tabReactions": "Liked {{formattedCount}}",
  "features_animHeader_tabSent": "Sent {{formattedCount}}",
  "features_animHeader_tabVisits": "Viewed {{formattedCount}}",
  "features_animHeader_visits": "Viewed you",
  "features_animHeader_visits_description": "Upgrade to {{subscriptionName}} to see who viewed you!",
  "features_animHeader_visits_description_subscriber": "Take a look at these people who viewed you!",
  "features_animHeader_visits_offer": "Get {{discountPercent}}% off {{subscriptionName}}\nto see who viewed you",
  "features_empty_info": "Send $t(smashes_other) or $t(super_smashes_other) to find your $t(matches_one)",
  "features_incomplete_profile_info": "Complete your profile to start getting $t(smashes_other) and $t(super_smashes_other)",
  "features_tab_label": "Liked You",
  "fill_profile_required_card_edit_cta": "Edit Profile",
  "fill_profile_required_card_title": "Complete your profile and start sending $t(smashes_other) and $t(super_smashes_other)",
  "fill_profile_required_incomplete_label": "Incomplete profile",
  "fill_profile_required_tip_subtitle": "Fill in the required fields to use this feature.",
  "fill_profile_tip_subtitle": "Complete your profile to help others discover you better.",
  "fill_profile_tip_subtitle_v2": "Help others get to know you better.",
  "fill_profile_tip_title": "Fill your profile",
  "fill_profile_tip_title_v2": "Complete your profile",
  "filter_continents_title": "Their continents",
  "filter_countries_title": "Their countries",
  "filter_ethnicities_title": "Their ethnicities",
  "filter_goals_title": "Their goals",
  "filter_interests_title": "Their interests",
  "filter_langs_title": "Languages they know",
  "filter_nationalities_title": "Their nationalities",
  "filters_add_continents_label": "Add location",
  "filters_add_countries_label": "Add countries",
  "filters_add_drinking_label": "Add frequency of use",
  "filters_add_education_level_label": "Add education level",
  "filters_add_ethnicities_label": "Add ethnicities",
  "filters_add_exercise_label": "Add activity to sports",
  "filters_add_goals_label": "Add goals",
  "filters_add_interests_label": "Add interests",
  "filters_add_kids_label": "Add children's presence",
  "filters_add_languages_label": "Add languages",
  "filters_add_marital_status_label": "Add marital status",
  "filters_add_nationalities_label": "Add nationalities",
  "filters_add_pets_label": "Add pets",
  "filters_add_religion_label": "Add religion",
  "filters_add_sex_orientation_label": "Add sexual orientation",
  "filters_add_smoking_label": "Add frequency of use",
  "filters_add_star_sign_label": "Add star sign",
  "filters_add_values_label": "Add values",
  "filters_advanced_footer_label": "The most advanced international filters in the dating space",
  "filters_gender_m": "Men",
  "filters_gender_u": "Both",
  "filters_gender_w": "Women",
  "filters_label_advanced": "Advanced filters",
  "filters_label_basic": "Basic filters",
  "filters_locations_continent_af": "Africa",
  "filters_locations_continent_as": "Asia",
  "filters_locations_continent_eu": "Europe",
  "filters_locations_continent_na": "North America",
  "filters_locations_continent_oc": "Oceania",
  "filters_locations_continent_sa": "South America",
  "filters_locations_continents_label": "Continents",
  "filters_locations_near": "Near",
  "filters_locations_range_label": "Range",
  "filters_locations_worldwide": "Worldwide",
  "filters_match_genders_error": "Please pick at least one option",
  "filters_option_age": "How old are they?",
  "filters_option_continents": "What is their location?",
  "filters_option_countries": "What country they are located in?",
  "filters_option_drinking": "How often they drink?",
  "filters_option_education_level": "What’s their education level?",
  "filters_option_ethnicities": "What's their ethnicities?",
  "filters_option_exercise": "Do they do sports?",
  "filters_option_goals": "What are their goals?",
  "filters_option_height": "How tall are they?",
  "filters_option_interests": "Do they share any of your interests?",
  "filters_option_kids": "Do they have kids?",
  "filters_option_languages": "What languages do they know?",
  "filters_option_marital_status": "What’s their marital status?",
  "filters_option_nationalities": "What's their nationalities?",
  "filters_option_pets": "Do they have pets?",
  "filters_option_religion": "What’s religion do they identify?",
  "filters_option_sex_orientation": "What’s their sexual orientation?",
  "filters_option_show_others": "Show other people if I run out",
  "filters_option_smoking": "How often they smoke?",
  "filters_option_star_sign": "What’s their star sign?",
  "filters_option_values": "What’s the most important thing in their life?",
  "filters_option_verified_only": "Have they verified themselves?",
  "filters_option_weight": "How much do they weigh?",
  "filters_title": "Search filters",
  "filters_upgrade_cta": "Upgrade",
  "filters_upgrade_description": "Fine-tune your filters with {{subscriptionName}}",
  "filters_value_age_from_to": "Age between {{from}} and {{to}}",
  "filters_value_any_age": "Any age is fine",
  "filters_value_any_height": "Any height is fine",
  "filters_value_any_weight": "Any weight is fine",
  "filters_value_height_from_to": "Height between {{from}} and {{to}}",
  "filters_value_weight_from_to": "Weight between {{from}} and {{to}}",
  "filters_verified_only": "Verified profiles only",
  "free_super_smashes_button": "Buy $t(super_smashes_other)",
  "free_super_smashes_subscription_button": "Get {{count}} $t(super_smashes) per day",
  "free_super_smashes_time_remain": "Next free $t(super_smashes_one) in:",
  "free_super_smashes_title": "Want a free $t(super_smashes_one)?\nWatch a short ad.",
  "gender_preference_title": "Who are you looking for?",
  "goal_chat_info": "Chat with people on different topics without serious plans yet",
  "goal_chat_title": "Chat and meet friends",
  "goal_learn_info": "Learn something new about the world and practice languages",
  "goal_learn_title": "Learn other cultures",
  "goal_marriage_info": "Find a person to get married to and build a joint future",
  "goal_marriage_title": "Get married",
  "goal_networking_info": "Connect with people who can help you reach your milestones",
  "goal_networking_title": "Networking",
  "goal_relationship_info": "Meet a soulmate, start a relationship, and then we'll see",
  "goal_relationship_title": "Find a relationship",
  "goal_title": "My goal",
  "goal_travel_info": "Meet travel partners and share experiences",
  "goal_travel_title": "Travel the world",
  "goal_unknown_title": "Unknown",
  "got_it": "Got it",
  "hidden": "Hidden",
  "hoursGenitive_one": "$t(hours_one)",
  "hoursGenitive_other": "$t(hours_other)",
  "hoursInstrumental_one": "$t(hours_one)",
  "hoursInstrumental_other": "$t(hours_other)",
  "hours_one": "hour",
  "hours_other": "hours",
  "image_save_failure_permission_subtitle": "Permission denied. Please allow photo permission for saving",
  "image_save_failure_title": "Image not saved",
  "image_save_failure_unknown_subtitle": "For some reason image was not saved, please try again later",
  "image_save_success": "Image saved ✅",
  "incognito_in_boost_alert_message": "Your $t(boosts_one) will stay active, but others won’t see your profile until Incognito mode is off.",
  "incognito_in_boost_alert_positive": "Turn on",
  "incognito_in_boost_alert_title": "Turn on Incognito mode?",
  "incomplete_profile_photos_required": "3 photos required",
  "instant_chat_cancel_alert_subtitle": "Your message won't be sent or saved.",
  "instant_chat_cancel_alert_title": "Discard Instant Chat?",
  "instant_chat_label": "Instant Сhat",
  "interests_category_else": "Others",
  "interests_category_food_and_drink": "Food and drink",
  "interests_category_going_out": "Going out",
  "interests_category_hobby": "Hobbies",
  "interests_category_music": "Music",
  "interests_category_pets": "Pets",
  "interests_category_sport": "Sport",
  "interests_category_travel": "Travels",
  "interests_food_and_drink_beer": "🍺 Beer",
  "interests_food_and_drink_cocktails": "🍸 Cocktails",
  "interests_food_and_drink_coffee": "☕ Coffee",
  "interests_food_and_drink_fast_food": "🍔 Fast food",
  "interests_food_and_drink_grill": "🍖 Grill",
  "interests_food_and_drink_home_food": "🥘 Home food",
  "interests_food_and_drink_pizza": "🍕 Pizza",
  "interests_food_and_drink_sushi": "🍣 Sushi",
  "interests_food_and_drink_sweets": "🍯 Sweets",
  "interests_food_and_drink_tea": "🫖 Tea",
  "interests_food_and_drink_vegan": "🌱 Vegan",
  "interests_food_and_drink_vegetarian": "🥬 Vegetarian",
  "interests_food_and_drink_whiskey": "🥃 Whiskey",
  "interests_food_and_drink_wine": "🍷 Wine",
  "interests_going_out_bars": "🍻 Bars",
  "interests_going_out_cafes": "☕ Cafes",
  "interests_going_out_concerts": "🎙 Concerts",
  "interests_going_out_galleries": "🖼 Galleries",
  "interests_going_out_hookah_bars": "💨 Hookah bars",
  "interests_going_out_karaoke": "🎤 Karaoke",
  "interests_going_out_museums": "🏺 Museums",
  "interests_going_out_nightclubs": "🪩 Nightclubs",
  "interests_going_out_restaurants": "🍲 Restaurants",
  "interests_going_out_theatres": "🎭 Theatres",
  "interests_hobbies_astronomy": "💫 Astronomy",
  "interests_hobbies_blogging": "🤳 Blogging",
  "interests_hobbies_board_games": "🎲 Board games",
  "interests_hobbies_cars": "🚗 Cars",
  "interests_hobbies_cooking": "🧑‍🍳 Cooking",
  "interests_hobbies_design": "✏ Design",
  "interests_hobbies_drawing": "🎨 Drawing",
  "interests_hobbies_fishing": "🎣 Fishing",
  "interests_hobbies_gardening": "🌻 Gardening",
  "interests_hobbies_healthy_lifestyle": "💪 Healthy lifestyle",
  "interests_hobbies_make_up": "💄 Make-up",
  "interests_hobbies_mind_games": "❓ Mind games",
  "interests_hobbies_music": "🎵 Music",
  "interests_hobbies_photography": "📸 Photography",
  "interests_hobbies_poetry": "✍ Poetry",
  "interests_hobbies_prose": "📝 Prose",
  "interests_hobbies_reading": "📚 Reading",
  "interests_hobbies_shooting_tiktok": "🎬 Shooting Tik-Tok",
  "interests_hobbies_shopping": "🛍 Shopping",
  "interests_hobbies_tattoos": "🃏 Tattoos",
  "interests_hobbies_tv": "📺 TV",
  "interests_hobbies_video_games": "🎮 Video games",
  "interests_hobbies_youtube": "📼 YouTube",
  "interests_music_art_song": "🎵 Art song",
  "interests_music_blues": "🎵 Blues",
  "interests_music_chanson": "🎵 Chanson",
  "interests_music_country": "🎵 Country",
  "interests_music_disco": "🎵 Disco",
  "interests_music_electronic": "🎵 Electronic music",
  "interests_music_folk": "🎵 Folk music",
  "interests_music_funk": "🎵 Funk",
  "interests_music_hiphop": "🎵 Hip-hop",
  "interests_music_jazz": "🎵 Jazz",
  "interests_music_latin_american": "🎵 Latin American music",
  "interests_music_new_wave": "🎵 New Wave",
  "interests_music_pop": "🎵 Pop",
  "interests_music_reggae": "🎵 Reggae",
  "interests_music_rnb": "🎵 R&B",
  "interests_music_rock": "🎵 Rock",
  "interests_music_romance": "🎵 Romance",
  "interests_music_soul": "🎵 Soul",
  "interests_other_astronomy": "⭐ Astronomy",
  "interests_other_beach_volleyball": "🏐 Beach volleyball",
  "interests_other_blm": "✊🏿 BLM",
  "interests_other_cakes": "🍰 Cakes",
  "interests_other_coffee_man": "☕ Coffeeman",
  "interests_other_content_creation": "📹 Content creation",
  "interests_other_cryptocurrency": "📈 Cryptocurrency",
  "interests_other_cs_go": "🔫 CS:GO",
  "interests_other_dc": "🦸‍ DC",
  "interests_other_delicious_food": "🥘 Delicious food",
  "interests_other_disney": "👸 Disney",
  "interests_other_doing_nothing": "🛋 Doing Nothing",
  "interests_other_dont_like_cold": "☀ Don't like cold",
  "interests_other_dragons": "🐉 Dragons",
  "interests_other_eco_activism": "🌎 Eco activism",
  "interests_other_entrepreneurship": "💸 Entrepreneurship",
  "interests_other_freelancing": "🧑‍💻 Freelancing",
  "interests_other_girls_under25": "👩 Girls under 25",
  "interests_other_gym": "🏋‍ Gym",
  "interests_other_happiness": "😊 Happiness",
  "interests_other_harry_potter": "🪄 Harry Potter",
  "interests_other_healthy_lifestyle": "🍏 Healthy lifestyle",
  "interests_other_human_rights": "⚖ Human rights",
  "interests_other_ice_cream": "🍦 Ice cream",
  "interests_other_instagram": "🤳 Instagram",
  "interests_other_learning_languages": "🔤 Learning languages",
  "interests_other_lgbtq": "🏳‍🌈 LGBTQ+",
  "interests_other_marvel": "🛡 Marvel",
  "interests_other_nature_protection": "🌳 Nature Protection",
  "interests_other_networking": "🌐 Networking",
  "interests_other_nft": "🖼 NFT",
  "interests_other_play_station": "🎮 PlayStation",
  "interests_other_poker": "🃏 Poker",
  "interests_other_procrastination": "🛌🏻 Procrastination",
  "interests_other_proper_nutrition": "🥗 Proper nutrition",
  "interests_other_shopaholic": "🛍 Shopaholic",
  "interests_other_sleep": "😴 Sleep",
  "interests_other_sneakers": "👟 Sneakers",
  "interests_other_startups": "🦄 Startups",
  "interests_other_tee_man": "🫖 Teeman",
  "interests_other_try_something_new": "🆕 Try something new",
  "interests_other_tv_shows": "🎥 TV Shows",
  "interests_other_twitter": "💬 Twitter",
  "interests_other_walking_in_the_rain": "🌧 Walking in the rain",
  "interests_other_workout_at_home": "🕴 Workout at home",
  "interests_other_world_peace": "☮ World peace",
  "interests_other_xbox": "🎮 XBox",
  "interests_pets_birds": "🐦 Birds",
  "interests_pets_cats": "🐈 Cats",
  "interests_pets_dogs": "🐕 Dogs",
  "interests_pets_fish": "🐠 Fish",
  "interests_pets_hamsters": "🐹 Hamsters",
  "interests_pets_rabbits": "🐇 Rabbits",
  "interests_pets_snakes": "🐍 Snakes",
  "interests_pets_turtles": "🐢 Turtles",
  "interests_sport_athletics": "🏃 Athletics",
  "interests_sport_badminton": "🏸 Badminton",
  "interests_sport_baseball": "⚾ Baseball",
  "interests_sport_basketball": "🏀 Basketball",
  "interests_sport_bodybuilding": "💪 Bodybuilding",
  "interests_sport_boxing": "🥊 Boxing",
  "interests_sport_climbing": "🧗 Climbing",
  "interests_sport_cycling": "🚴 Cycling",
  "interests_sport_dancing": "💃 Dancing",
  "interests_sport_esports": "💻 eSports",
  "interests_sport_fencing": "🤺 Fencing",
  "interests_sport_football": "⚽ Football",
  "interests_sport_formula1": "🏎 Formula 1",
  "interests_sport_gymnastics": "🤸 Gymnastics",
  "interests_sport_handball": "🤾 Handball",
  "interests_sport_hockey": "🏒 Hockey",
  "interests_sport_joga": "🧘 Yoga",
  "interests_sport_judo": "🥋 Judo",
  "interests_sport_meditation": "🧘 Meditation",
  "interests_sport_pilates": "🤸 Pilates",
  "interests_sport_rowing": "🚣 Rowing",
  "interests_sport_running": "🏃 Running",
  "interests_sport_shooting_sports": "🔫 Shooting sports",
  "interests_sport_surf": "🏄 Surfing",
  "interests_sport_swimming": "🏊 Swimming",
  "interests_sport_table_tennis": "🏓 Table tennis",
  "interests_sport_tennis": "🎾 Tennis",
  "interests_sport_triathlon": "🦾 Triathlon",
  "interests_sport_volleyball": "🏐 Volleyball",
  "interests_sport_water_polo": "🤽 Water polo",
  "interests_sport_weightlifting": "🏋 Weightlifting",
  "interests_sport_wrestling": "🤼 Wrestling",
  "interests_travel_abroad": "✈ Abroad",
  "interests_travel_attractions": "🗼 Attractions",
  "interests_travel_camping": "🏕 Camping",
  "interests_travel_cities": "🌇 Cities",
  "interests_travel_domestic": "🧳 Domestic",
  "interests_travel_hiking": "🧭 Hiking",
  "interests_travel_mountains": "⛰ Mountains",
  "interests_travel_nature": "🌳 Nature",
  "interests_travel_seas": "🌊 Seas",
  "item_i_of_n": "{{index}} of {{count}}",
  "kids_child_free": "Childfree",
  "kids_more_than_3": "More than 3",
  "kids_not_yet": "Not yet",
  "languages_title": "Languages I know",
  "last_photo_removed_notification_description": "Your photo was removed because it doesn’t meet our rules. Upload a new one to keep using {{appName}}.",
  "last_photo_removed_notification_title": "Your photo was removed",
  "later": "Later",
  "legal_updated_cta": "Agree & Continue",
  "legal_updated_info": "By tapping “$t(legal_updated_cta)”, you agree to the updated $t(terms_of_service) and confirm you’ve reviewed the $t(privacy_policy).",
  "legal_updated_reviewed_cta": "I’ve reviewed this",
  "legal_updated_subtitle": "We’ve updated our $t(terms_of_service) and $t(privacy_policy). Please review the documents before continuing.",
  "legal_updated_title": "Important Updates",
  "liked_you_label": "Liked you",
  "loading": "Loading...",
  "location_title": "My location",
  "location_verification": "Location verification request",
  "location_verification_error_alert_message": "Sorry, location verification is not available now. Please try again later",
  "location_verification_pending": "Verifying location...",
  "location_verification_sent_already": "Location verification request is already sent.",
  "location_verified_description": "Your location was verified on {{date}}",
  "location_verified_title": "Location verified",
  "main_become_ambassador": "Become a {{appName}} Ambassador",
  "main_contact_faq": "Contact & FAQ",
  "main_contact_us": "Contact us",
  "main_reset_onboardings": "Activate tips",
  "main_restore_purchase": "Restore purchase",
  "main_subscription_dont_show_online": "Hide my online status",
  "main_subscription_hide_my_age": "Hide my age",
  "main_subscription_hide_my_distance": "Hide my country and city",
  "main_subscription_incognito": "Incognito mode",
  "main_subscription_incognito_info": "Enable Incognito mode, so no one sees your profile unless you want them to. Only people you sent $t(smashes_other) will be able to see your profile.",
  "main_subscription_visibility": "Visibility",
  "main_tab_activate_subscription": "Upgrade to {{subscriptionName}}",
  "main_tab_empty_subtitle": "Meet new people to start communicating",
  "main_tab_empty_title": "You'll see your $t(matches_other) here",
  "main_tab_incomplete_profile_subtitle": "Complete your profile to start getting $t(matches_other)",
  "main_tab_match_reaction_bottom_info": "Recently active, $t(matches_one) now!",
  "main_tab_match_reaction_liked_you": "Liked you",
  "main_tab_message_item_calls_canceled_audio_call": "Canceled audio call",
  "main_tab_message_item_calls_canceled_video_call": "Canceled video call",
  "main_tab_message_item_calls_declined_audio_call": "Declined audio call",
  "main_tab_message_item_calls_declined_video_call": "Declined video call",
  "main_tab_message_item_calls_failed_audio_call": "Failed audio call",
  "main_tab_message_item_calls_failed_video_call": "Failed video call",
  "main_tab_message_item_calls_permission_approved": "Call request approved",
  "main_tab_message_item_calls_permission_canceled": "Call request canceled",
  "main_tab_message_item_calls_permission_declined": "Call request declined",
  "main_tab_message_item_calls_permission_request": "Call request",
  "main_tab_message_item_calls_permission_revoked": "Call request revoked",
  "main_tab_message_item_last_message_photo_to_me": "Photo sent to you",
  "main_tab_message_item_last_message_photo_your": "You sent a photo",
  "main_tab_message_item_prompt_chat_cta": "Text",
  "main_tab_message_item_prompt_chat_title": "You got a new $t(matches_one)! Text $t(one_dative_gender) right now!",
  "main_tab_message_item_reaction": "Like ❤️ your message",
  "main_tab_open_match_closed": "Closed",
  "main_tab_open_match_closed_info_description": "The chat will automatically disappear {{willRemoveAt}}",
  "main_tab_open_match_closed_info_title_by_other": "{{firstName}} has closed this chat.",
  "main_tab_open_match_closed_info_title_by_you": "This chat has been closed by you.",
  "main_tab_open_match_expired": "Expired",
  "main_tab_open_match_your_turn": "Your turn",
  "main_tab_subscribed_cta_check_reactions": "check my $t(smashes_other)",
  "main_tab_subscribed_cta_check_visits": "check my Visits",
  "main_tab_subscribed_discover_prompt": "Be active - send $t(smashes_other) to start chatting",
  "main_tab_suggestion_add_more_avatars": "Add your photos to increase the chance of getting new $t(matches_other)",
  "main_tab_suggestion_enable_notifications": "Allow notifications and never miss new $t(matches_other)",
  "main_tab_suggestion_pass_location_verification": "Pass location verification to increase the chance of getting new $t(matches_other)",
  "main_tab_suggestion_pass_photo_verification": "Pass photo verification to increase the chance of getting new $t(matches_other)",
  "main_tab_top_reactions_prompt": "Don't miss your $t(matches_other)",
  "main_tab_top_reactions_title": "See who liked you. Already ",
  "main_tab_your_reactions_cta": "See who liked you",
  "main_tab_your_reactions_subtitle": "Don't miss people who want to chat with you",
  "main_tab_your_reactions_title": "People who liked you",
  "main_version": "Version",
  "mandatory_photo_verification_pending_subtitle": "You’ll be able to use the app once your photo is verified.",
  "mandatory_photo_verification_start_cta": "Verify photo now",
  "mandatory_photo_verification_start_subtitle": "To keep the {{appName}} community safe, we need to verify your photo.",
  "mandatory_photo_verification_start_title": "Verify your photo to continue",
  "many_gender_female": "Women",
  "many_gender_male": "Men",
  "many_gender_nonBinary": "Non Binary",
  "many_gender_transFemale": "Trans Women",
  "many_gender_transMale": "Trans Men",
  "map_tab_label": "Map",
  "marital_status_divorced": "Divorced",
  "marital_status_in_a_relationship": "In a relationship",
  "marital_status_married": "Married",
  "marital_status_separated": "Separated",
  "marital_status_single": "Single",
  "match_call_permission_prompt_message": "Send a request for permission to make calls?",
  "match_call_permission_prompt_positive": "Send",
  "match_call_permission_requested_earlier": "Call request already sent",
  "match_expiration_label_source": "Your chat expires in {{time}} if {{name}} doesn’t reply",
  "match_expiration_label_target": "Your chat expires in {{time}} — send a message now",
  "match_expiration_notification": "Chat with {{name}} expires in {{time}} — send a message now",
  "match_expired_text": "It will be removed on {{time}}.",
  "match_expired_title": "This chat has expired.",
  "match_location_verification_request_already": "{{name}} has already completed location verification.",
  "match_location_verification_request_description": "{{name}} won’t be able to send messages until location verification is complete.",
  "match_location_verification_request_title": "Ask {{name}} to pass location verification",
  "match_notifications_enabled": "We’ll notify you when $t(one_nominative_gender) comes online",
  "match_online_status": "Online status",
  "match_online_status_description": "Get notified when {{name}} comes online",
  "match_verification_request_already": "{{name}} has already completed photo verification.",
  "match_verification_request_description": "{{name}} won’t be able to send messages until photo verification is complete.",
  "match_verification_request_title": "Ask {{name}} to pass photo verification",
  "matches_filter": "Filter chats",
  "matches_filter_active": "Active",
  "matches_filter_all": "All",
  "matches_filter_unread": "Unread",
  "matches_label": "Chats",
  "media_album_selector_title": "Select album",
  "media_item_selector_album_recent": "Recent",
  "media_item_selector_image_allow_permission_cta": "Allow access to photos",
  "media_item_selector_image_no_albums_label": "Looks like you don’t have any photos to upload. Want to take now?",
  "media_item_selector_image_no_permission_label": "Allow {{appName}} to access your photos so you can choose which to put on your profile.",
  "media_item_selector_image_title": "Select photo",
  "media_item_selector_selected": "{{selected}}/{{maxSelection}} selected",
  "media_item_selector_video_allow_permission_cta": "Allow access to videos",
  "media_item_selector_video_no_albums_label": "Looks like you don’t have any videos to upload. Want to take now?",
  "media_item_selector_video_no_permission_label": "Allow {{appName}} access to your videos so that you can choose which ones you want to submit for the contest.",
  "media_item_selector_video_not_allowed_message": "This video is not available for selection. It does not meet the upload requirements.",
  "media_item_selector_video_take_cta": "Take a video",
  "media_item_selector_video_title": "Select video",
  "media_preview_add_caption": "Add caption",
  "media_selector_camera": "Open camera",
  "media_selector_camera_preview_retake": "Retake",
  "media_selector_gallery": "Choose from gallery",
  "media_selector_unsupported_photo_alert_message": "This photo isn’t supported. Please, choose another one...",
  "media_selector_unsupported_photo_alert_title": "Oops!",
  "meet_new_people_cta": "Meet new people",
  "message_limitation_common_prefix_pending_subtitle": "Your profile is being verified. As soon as the verification is completed,",
  "message_limitation_keyword_none_subtitle": "Pass verification to send messages without limits.",
  "message_limitation_keyword_pending_subtitle": "$t(message_limitation_common_prefix_pending_subtitle) you'll be able to send words without limits.",
  "message_limitation_photo_none_subtitle": "Pass verification to be able to send photos.",
  "message_limitation_photo_pending_subtitle": "$t(message_limitation_common_prefix_pending_subtitle) you'll be able to send photos.",
  "message_limitation_title": "Attention",
  "message_unable_to_send_alert_title": "This message cannot be sent.",
  "messages_compliment_accept": "Accept",
  "messages_compliment_info": "Accept it to start chatting!",
  "messages_compliment_title": "Accept the compliment from {{firstName}}?",
  "messages_dangerous_chat_item": "Avoid switching to other messengers until you trust this person.",
  "messages_dangerous_contacts_item": "No personal info like phone numbers until you trust the person.",
  "messages_dangerous_dont_send": "Don't send",
  "messages_dangerous_money_item": "Never send money or payment info. Scammers can exploit your trust.",
  "messages_dangerous_offensive_item": "Your message may be offensive and lead to harassment.",
  "messages_dangerous_report_item": "If {{firstName}} reports this message, your account could be suspended.",
  "messages_dangerous_rude_item": "Protect yourself - some users can be offensive.",
  "messages_dangerous_send": "Send",
  "messages_dangerous_share_title": "This message may be unsafe. Do you want to send it?",
  "messages_dangerous_view_photo_title": "This photo may be unsafe. Do you want to view it?",
  "messages_dangerous_view_title": "This message may be unsafe. Do you want to view it?",
  "messages_gif_no_content": "No GIFs to show",
  "messages_gif_placeholder": "Search {{provider}}...",
  "messages_input_placeholder": "Message",
  "messages_input_reply_to": "Reply to {{firstName}}",
  "messages_item_call_permission_approved": "Calls approved",
  "messages_item_call_permission_canceled": "Calls request canceled",
  "messages_item_call_permission_declined": "Calls declined",
  "messages_item_call_permission_revoked": "Calls revoked",
  "messages_item_call_permission_sent": "Calls request sent",
  "messages_item_has_seen": "Has {{firstName}} seen your message?",
  "messages_item_info_edited": "edited",
  "messages_item_info_view": "View",
  "messages_item_location_verification_complete": "Location verification completed",
  "messages_item_menu_cancel_call_request": "Cancel request",
  "messages_item_menu_copy": "Copy",
  "messages_item_menu_copy_original": "Copy original",
  "messages_item_menu_copy_tr": "Copy translation",
  "messages_item_menu_delete": "Delete",
  "messages_item_menu_edit": "Edit",
  "messages_item_menu_reply": "Reply",
  "messages_item_menu_report": "Report",
  "messages_item_menu_resend": "Resend",
  "messages_item_menu_save_image": "Save Image",
  "messages_item_menu_show_original": "Show original",
  "messages_item_my_call_canceled": "Call canceled",
  "messages_item_my_call_declined": "Call declined",
  "messages_item_my_call_failed": "Call failed",
  "messages_item_my_location_verification_request": "Request to pass location verification sent",
  "messages_item_my_photo_verification_request": "Request to pass photo verification sent",
  "messages_item_my_sensitive": "This may be sensitive. Want to delete it?",
  "messages_item_my_suspicious": "This may be unsafe. Want to delete it?",
  "messages_item_other_location_verification_request": "{{name}} has requested location verification. Complete it to keep chatting.",
  "messages_item_other_photo_verification_request": "{{name}} has requested photo verification. Complete it to keep chatting.",
  "messages_item_other_suspicious": "Do you want to close the chat and report?",
  "messages_may_be_dangerous": "This may be unsafe",
  "messages_may_be_sensitive": "This may be sensitive",
  "messages_menu_call_audio": "Make audio call",
  "messages_menu_call_video": "Make video call",
  "messages_menu_cancel_call_permission": "Cancel call request",
  "messages_menu_decline_call_permission": "Decline call request",
  "messages_menu_favourites_add": "Add to Favorites",
  "messages_menu_favourites_remove": "Remove from Favorites",
  "messages_menu_revoke_call_permission": "Revoke call access",
  "messages_menu_view_profile": "View profile",
  "messages_prompt_push_enable_subtitle": "Allow notifications",
  "messages_prompt_push_enable_title": "Find out when {{firstName}} replies",
  "messages_sensitive_attention_title": "This photo may be sensitive. Do you want to view it?",
  "messages_sensitive_info_body": "Photos showing nudity include private body parts usually covered by underwear or swimwear.",
  "messages_sensitive_info_smile": "It's not your fault, but such photos can be used against you.",
  "messages_suspicious_text_hidden": "Text hidden",
  "messages_title_online": "Active now",
  "messages_uploading_image": "Uploading image",
  "minutesGenitive_one": "$t(minutes_one)",
  "minutesGenitive_other": "$t(minutes_other)",
  "minutesInstrumental_one": "$t(minutes_one)",
  "minutesInstrumental_other": "$t(minutes_other)",
  "minutes_one": "minute",
  "minutes_other": "minutes",
  "monthsGenitive_one": "$t(months_one)",
  "monthsGenitive_other": "$t(months_other)",
  "monthsInstrumental_one": "$t(months_one)",
  "monthsInstrumental_other": "$t(months_other)",
  "months_one": "month",
  "months_other": "months",
  "most_popular": "most popular",
  "my_account_operations_delete_alert_button": "Delete",
  "my_account_operations_delete_alert_message": "You'll lose all your $t(matches_other) and messages",
  "my_account_operations_freeze": "Freeze account",
  "my_account_operations_freeze_alert_button": "Freeze",
  "my_account_operations_freeze_alert_message": "You can sign in your account in any time",
  "my_account_operations_freeze_alert_title": "Are you sure you want to freeze your account?",
  "my_account_operations_freeze_info": "You can deactivate your account and restore it anytime",
  "my_account_operations_header": "Here you can logout from the app. To get back in the app, just log in the same way as you registered.",
  "my_account_operations_id_copied": "ID copied",
  "my_account_operations_sign_out": "Logout",
  "my_account_operations_sign_out_alert_button": "Logout",
  "my_account_operations_sign_out_alert_message": "You can log in to account at any time",
  "my_account_operations_sign_out_alert_title": "Are you sure you want to logout?",
  "my_ethnicities_common_title": "My ethnicities",
  "my_interests_title": "My interests",
  "my_nationalities_common_title": "My nationalities",
  "my_photo_verification_button_done": "Photo verified",
  "my_photo_verification_button_error": "Photo verification failed",
  "nationality_afghanistan": "🇦🇫 Afghanistan",
  "nationality_albania": "🇦🇱 Albania",
  "nationality_algeria": "🇩🇿 Algeria",
  "nationality_andorra": "🇦🇩 Andorra",
  "nationality_angola": "🇦🇴 Angola",
  "nationality_antigua_and_barbuda": "🇦🇬 Antigua and Barbuda",
  "nationality_argentina": "🇦🇷 Argentina",
  "nationality_armenia": "🇦🇲 Armenia",
  "nationality_australia": "🇦🇺 Australia",
  "nationality_austria": "🇦🇹 Austria",
  "nationality_azerbaijan": "🇦🇿 Azerbaijan",
  "nationality_bahamas": "🇧🇸 Bahamas",
  "nationality_bahrain": "🇧🇭 Bahrain",
  "nationality_bangladesh": "🇧🇩 Bangladesh",
  "nationality_barbados": "🇧🇧 Barbados",
  "nationality_belarus": "🇧🇾 Belarus",
  "nationality_belgium": "🇧🇪 Belgium",
  "nationality_belize": "🇧🇿 Belize",
  "nationality_benin": "🇧🇯 Benin",
  "nationality_bhutan": "🇧🇹 Bhutan",
  "nationality_bolivia": "🇧🇴 Bolivia",
  "nationality_bosnia_and_herzegovina": "🇧🇦 Bosnia and Herzegovina",
  "nationality_botswana": "🇧🇼 Botswana",
  "nationality_brazil": "🇧🇷 Brazil",
  "nationality_brunei": "🇧🇳 Brunei",
  "nationality_bulgaria": "🇧🇬 Bulgaria",
  "nationality_burkina_faso": "🇧🇫 Burkina Faso",
  "nationality_burundi": "🇧🇮 Burundi",
  "nationality_cabo_verde": "🇨🇻 Cabo Verde",
  "nationality_cambodia": "🇰🇭 Cambodia",
  "nationality_cameroon": "🇨🇲 Cameroon",
  "nationality_canada": "🇨🇦 Canada",
  "nationality_central_african_republic": "🇨🇫 Central African Republic",
  "nationality_chad": "🇹🇩 Chad",
  "nationality_chile": "🇨🇱 Chile",
  "nationality_china": "🇨🇳 China",
  "nationality_colombia": "🇨🇴 Colombia",
  "nationality_comoros": "🇰🇲 Comoros",
  "nationality_congo_drc": "🇨🇩 Congo (DRC)",
  "nationality_congo_republic": "🇨🇬 Congo (Republic)",
  "nationality_costa_rica": "🇨🇷 Costa Rica",
  "nationality_cote_divoire": "🇨🇮 Côte d'Ivoire",
  "nationality_croatia": "🇭🇷 Croatia",
  "nationality_cuba": "🇨🇺 Cuba",
  "nationality_cyprus": "🇨🇾 Cyprus",
  "nationality_czech_republic": "🇨🇿 Czech Republic",
  "nationality_denmark": "🇩🇰 Denmark",
  "nationality_djibouti": "🇩🇯 Djibouti",
  "nationality_dominica": "🇩🇲 Dominica",
  "nationality_dominican_republic": "🇩🇴 Dominican Republic",
  "nationality_ecuador": "🇪🇨 Ecuador",
  "nationality_egypt": "🇪🇬 Egypt",
  "nationality_el_salvador": "🇸🇻 El Salvador",
  "nationality_equatorial_guinea": "🇬🇶 Equatorial Guinea",
  "nationality_eritrea": "🇪🇷 Eritrea",
  "nationality_estonia": "🇪🇪 Estonia",
  "nationality_eswatini": "🇸🇿 Eswatini",
  "nationality_ethiopia": "🇪🇹 Ethiopia",
  "nationality_fiji": "🇫🇯 Fiji",
  "nationality_finland": "🇫🇮 Finland",
  "nationality_france": "🇫🇷 France",
  "nationality_gabon": "🇬🇦 Gabon",
  "nationality_gambia": "🇬🇲 Gambia",
  "nationality_georgia": "🇬🇪 Georgia",
  "nationality_germany": "🇩🇪 Germany",
  "nationality_ghana": "🇬🇭 Ghana",
  "nationality_greece": "🇬🇷 Greece",
  "nationality_grenada": "🇬🇩 Grenada",
  "nationality_guatemala": "🇬🇹 Guatemala",
  "nationality_guinea": "🇬🇳 Guinea",
  "nationality_guinea_bissau": "🇬🇼 Guinea-Bissau",
  "nationality_guyana": "🇬🇾 Guyana",
  "nationality_haiti": "🇭🇹 Haiti",
  "nationality_honduras": "🇭🇳 Honduras",
  "nationality_hungary": "🇭🇺 Hungary",
  "nationality_iceland": "🇮🇸 Iceland",
  "nationality_india": "🇮🇳 India",
  "nationality_indonesia": "🇮🇩 Indonesia",
  "nationality_iran": "🇮🇷 Iran",
  "nationality_iraq": "🇮🇶 Iraq",
  "nationality_ireland": "🇮🇪 Ireland",
  "nationality_israel": "🇮🇱 Israel",
  "nationality_italy": "🇮🇹 Italy",
  "nationality_jamaica": "🇯🇲 Jamaica",
  "nationality_japan": "🇯🇵 Japan",
  "nationality_jordan": "🇯🇴 Jordan",
  "nationality_kazakhstan": "🇰🇿 Kazakhstan",
  "nationality_kenya": "🇰🇪 Kenya",
  "nationality_kiribati": "🇰🇮 Kiribati",
  "nationality_kosovo": "🇽🇰 Kosovo",
  "nationality_kuwait": "🇰🇼 Kuwait",
  "nationality_kyrgyzstan": "🇰🇬 Kyrgyzstan",
  "nationality_laos": "🇱🇦 Laos",
  "nationality_latvia": "🇱🇻 Latvia",
  "nationality_lebanon": "🇱🇧 Lebanon",
  "nationality_lesotho": "🇱🇸 Lesotho",
  "nationality_liberia": "🇱🇷 Liberia",
  "nationality_libya": "🇱🇾 Libya",
  "nationality_liechtenstein": "🇱🇮 Liechtenstein",
  "nationality_lithuania": "🇱🇹 Lithuania",
  "nationality_luxembourg": "🇱🇺 Luxembourg",
  "nationality_madagascar": "🇲🇬 Madagascar",
  "nationality_malawi": "🇲🇼 Malawi",
  "nationality_malaysia": "🇲🇾 Malaysia",
  "nationality_maldives": "🇲🇻 Maldives",
  "nationality_mali": "🇲🇱 Mali",
  "nationality_malta": "🇲🇹 Malta",
  "nationality_marshall_islands": "🇲🇭 Marshall Islands",
  "nationality_mauritania": "🇲🇷 Mauritania",
  "nationality_mauritius": "🇲🇺 Mauritius",
  "nationality_mexico": "🇲🇽 Mexico",
  "nationality_micronesia": "🇫🇲 Micronesia",
  "nationality_moldova": "🇲🇩 Moldova",
  "nationality_monaco": "🇲🇨 Monaco",
  "nationality_mongolia": "🇲🇳 Mongolia",
  "nationality_montenegro": "🇲🇪 Montenegro",
  "nationality_morocco": "🇲🇦 Morocco",
  "nationality_mozambique": "🇲🇿 Mozambique",
  "nationality_myanmar_burma": "🇲🇲 Myanmar (Burma)",
  "nationality_namibia": "🇳🇦 Namibia",
  "nationality_nauru": "🇳🇷 Nauru",
  "nationality_nepal": "🇳🇵 Nepal",
  "nationality_netherlands": "🇳🇱 Netherlands",
  "nationality_new_zealand": "🇳🇿 New Zealand",
  "nationality_nicaragua": "🇳🇮 Nicaragua",
  "nationality_niger": "🇳🇪 Niger",
  "nationality_nigeria": "🇳🇬 Nigeria",
  "nationality_north_korea": "🇰🇵 North Korea",
  "nationality_north_macedonia": "🇲🇰 North Macedonia",
  "nationality_norway": "🇳🇴 Norway",
  "nationality_oman": "🇴🇲 Oman",
  "nationality_pakistan": "🇵🇰 Pakistan",
  "nationality_palau": "🇵🇼 Palau",
  "nationality_palestine": "🇵🇸 Palestine",
  "nationality_panama": "🇵🇦 Panama",
  "nationality_papua_new_guinea": "🇵🇬 Papua New Guinea",
  "nationality_paraguay": "🇵🇾 Paraguay",
  "nationality_peru": "🇵🇪 Peru",
  "nationality_philippines": "🇵🇭 Philippines",
  "nationality_poland": "🇵🇱 Poland",
  "nationality_portugal": "🇵🇹 Portugal",
  "nationality_puerto_rico": "🇵🇷 Puerto Rico",
  "nationality_qatar": "🇶🇦 Qatar",
  "nationality_romania": "🇷🇴 Romania",
  "nationality_russia": "🇷🇺 Russia",
  "nationality_rwanda": "🇷🇼 Rwanda",
  "nationality_saint_kitts_and_nevis": "🇰🇳 Saint Kitts and Nevis",
  "nationality_saint_lucia": "🇱🇨 Saint Lucia",
  "nationality_saint_vincent_and_the_grenadines": "🇻🇨 Saint Vincent and the Grenadines",
  "nationality_samoa": "🇼🇸 Samoa",
  "nationality_san_marino": "🇸🇲 San Marino",
  "nationality_sao_tome_and_principe": "🇸🇹 Sao Tome and Principe",
  "nationality_saudi_arabia": "🇸🇦 Saudi Arabia",
  "nationality_senegal": "🇸🇳 Senegal",
  "nationality_serbia": "🇷🇸 Serbia",
  "nationality_seychelles": "🇸🇨 Seychelles",
  "nationality_sierra_leone": "🇸🇱 Sierra Leone",
  "nationality_singapore": "🇸🇬 Singapore",
  "nationality_slovakia": "🇸🇰 Slovakia",
  "nationality_slovenia": "🇸🇮 Slovenia",
  "nationality_solomon_islands": "🇸🇧 Solomon Islands",
  "nationality_somalia": "🇸🇴 Somalia",
  "nationality_south_africa": "🇿🇦 South Africa",
  "nationality_south_korea": "🇰🇷 South Korea",
  "nationality_south_sudan": "🇸🇸 South Sudan",
  "nationality_spain": "🇪🇸 Spain",
  "nationality_sri_lanka": "🇱🇰 Sri Lanka",
  "nationality_sudan": "🇸🇩 Sudan",
  "nationality_suriname": "🇸🇷 Suriname",
  "nationality_sweden": "🇸🇪 Sweden",
  "nationality_switzerland": "🇨🇭 Switzerland",
  "nationality_syria": "🇸🇾 Syria",
  "nationality_taiwan": "🇹🇼 Taiwan",
  "nationality_tajikistan": "🇹🇯 Tajikistan",
  "nationality_tanzania": "🇹🇿 Tanzania",
  "nationality_thailand": "🇹🇭 Thailand",
  "nationality_timor_leste": "🇹🇱 Timor-Leste",
  "nationality_togo": "🇹🇬 Togo",
  "nationality_tonga": "🇹🇴 Tonga",
  "nationality_trinidad_and_tobago": "🇹🇹 Trinidad and Tobago",
  "nationality_tunisia": "🇹🇳 Tunisia",
  "nationality_turkey": "🇹🇷 Turkey",
  "nationality_turkmenistan": "🇹🇲 Turkmenistan",
  "nationality_tuvalu": "🇹🇻 Tuvalu",
  "nationality_uganda": "🇺🇬 Uganda",
  "nationality_ukraine": "🇺🇦 Ukraine",
  "nationality_united_arab_emirates": "🇦🇪 United Arab Emirates",
  "nationality_united_kingdom": "🇬🇧 United Kingdom",
  "nationality_united_states": "🇺🇸 United States",
  "nationality_uruguay": "🇺🇾 Uruguay",
  "nationality_uzbekistan": "🇺🇿 Uzbekistan",
  "nationality_vanuatu": "🇻🇺 Vanuatu",
  "nationality_vatican_city": "🇻🇦 Vatican City",
  "nationality_venezuela": "🇻🇪 Venezuela",
  "nationality_vietnam": "🇻🇳 Vietnam",
  "nationality_yemen": "🇾🇪 Yemen",
  "nationality_zambia": "🇿🇲 Zambia",
  "nationality_zimbabwe": "🇿🇼 Zimbabwe",
  "need_help_choosing_photo_label": "Unclear on what to upload?",
  "network_issue_off_subtitle": "Сonnection to the Internet has been lost.",
  "network_issue_off_title": "Ooops!",
  "network_issue_on_subtitle": "The connection has been restored. Enjoy the app to the fullest.",
  "network_issue_on_title": "Wow!",
  "never": "Never",
  "new_match_placeholder": "Type a message",
  "new_match_prompt_short": "You like $t(one_dative_gender)!",
  "new_match_suggestions_child_dream": "Hello 👋 What did you want to be as a child? Has this dream come true?",
  "new_match_suggestions_country_facts": "Hello 👋 Tell me three interesting facts about your country, and I'll tell you about mine!",
  "new_match_suggestions_dream_superpower": "Hello 👋 What superpower do you dream about?",
  "new_match_suggestions_dream_visiting_country": "Hello 👋 Tell me which country do you dream of visiting?",
  "new_match_suggestions_fav_movie": "Hello 👋 Do you prefer to watch a new movie or watch your favorite one again?",
  "new_match_suggestions_languages": "Hello 👋 How many languages do you know?",
  "new_match_title_1": "It's a",
  "new_matches_label": "New $t(matches_other)",
  "new_night_time": "Notify when $t(one_nominative_gender) comes online",
  "new_night_time_title": "{{name}}'s offline. It’s {{time}} $t(one_possessive_gender_for_time) time.",
  "new_register_step_build_my_profile_subtitle": "Answer a few quick questions and we’ll find the right person for you anywhere in the world.",
  "new_register_step_build_my_profile_title": "{{name}}, let’s find your perfect match",
  "next": "Next",
  "no": "No",
  "no_valid_profile_info_alert_message": "Your info violated Community Guidelines. For more details, please see profile safety tips.",
  "notification_become_ambassador": "Let’s grow together! Become a {{appName}} Ambassador.",
  "notification_boost_expired": "$t(boosts_one) ended. See who liked you.",
  "notification_call_permission_approved_title_from": "{{firstName}} approved call request",
  "notification_call_permission_declined_title_from": "{{firstName}} declined call request",
  "notification_call_permission_requested_title_from": "{{firstName}} sent a call request",
  "notification_favourites_title": "{{firstName}} favorited you",
  "notification_favourites_title_anonymous": "Someone favorited you",
  "notification_filters_extended": "Out of people for now! Here are some outside your filters.",
  "notification_missed_match_subtitle": "Upgrade to {{subscriptionName}} to see all missed $t(matches_other)!",
  "notification_missed_match_title": "You've missed {{count}} {{matches}}!",
  "notification_new_match_subtitle": "Start a chat with {{firstName}}",
  "notification_new_match_title": "New $t(matches_one)!",
  "notification_new_message_reaction_title_from": "{{firstName}} liked your message",
  "notification_new_message_title_from": "{{firstName}} sent you a message",
  "notification_settings_title": "Notification settings",
  "notification_subscription_instead_reveal_subtitle": "Upgrade to {{subscriptionName}} to save your money",
  "notification_subscription_instead_reveal_title": "You've purchased {{count}} {{reveals}}!",
  "notification_title_completed_location_verification": "{{name}} has completed location verification",
  "notification_title_completed_photo_verification": "{{name}} has completed photo verification",
  "notification_title_free_reveal_available": "Your free Reveal is available",
  "notification_title_requested_location_verification": "{{name}} sent location verification request",
  "notification_title_requested_photo_verification": "{{name}} sent photo verification request",
  "notification_title_smash_invisible": "You got $t(smashes_one) from someone",
  "notification_title_smash_visible": "{{firstName}} just sent you $t(smashes_one)",
  "notification_title_super_smash": "{{firstName}} has given you a special sympathy - $t(super_smashes_one)",
  "notification_title_user_online": "{{name}} is online now 🟢",
  "notification_title_visit_invisible": "Someone viewed your profile",
  "notification_title_visit_visible": "{{firstName}} just viewed your profile",
  "notification_verification_success_title": "Photo verification completed",
  "notifications_common_title_new_messages": "New messages",
  "notifications_common_title_new_smashes": "New $t(smashes_other)",
  "notifications_common_title_new_super_smashes": "New $t(super_smashes_other)",
  "notifications_common_title_new_visits": "New viewers",
  "notifications_in_app_setting_label": "In-app notifications",
  "notifications_list_header": "Choose what activities matter to you for staying connected",
  "notifications_matches_settings_title": "Get updates about your new $t(matches_other)",
  "notifications_message_settings": "Message notifications",
  "notifications_message_settings_common_title": "Disabling this notification means missing out on new messages from your connections",
  "notifications_other_settings": "Other notifications",
  "notifications_push_setting_label": "Push notifications",
  "notifications_smashes_settings_title": "Get updates about people who sent new $t(smashes_other) to you",
  "notifications_super_smashes_settings_title": "Get updates about people who sent new $t(super_smashes_other) to you",
  "notifications_visits_settings_title": "Get updates about people who viewed you",
  "offer_benefit_unlimited_smashes_title": "Send compliments",
  "offer_btn_show_all_prices": "View all prices",
  "offer_discount_info_title": "Recurring payments. Cancellation at any time. Renewal at your current offer price.",
  "offer_discount_notification_title": "Get {{discountPercent}}% off {{appName}} {{subscriptionName}}!",
  "offer_discount_price": "your {{period}} price: ",
  "offer_discount_title": "Get {{discountPercent}}% off a {{duration}} subscription",
  "offer_ends_notification_title": "{{time}} left - {{discountPercent}}% off ends soon!",
  "offer_info_ios": "The amount will be charged through your iTunes account, and the subscription will be renewed for {{price}} for one month unless you cancel it in your iTunes Store settings. By clicking “Continue” you agree to our Terms and Conditions and automatic subscription renewal.",
  "offer_price_after": "Price when renewing after {{period}}: {{price}}",
  "offer_subheader": "Only today",
  "offer_until_text": "Offer ends in",
  "offer_usual_price": "standard price: ",
  "often": "Often",
  "ok": "Okay",
  "onboarding_was_reset_alert_notice_message": "Tips are activated",
  "one_dative_gender_female": "her",
  "one_dative_gender_male": "him",
  "one_dative_gender_nonBinary": "them",
  "one_gender_female": "Female",
  "one_gender_male": "Male",
  "one_gender_nonBinary": "Non Binary",
  "one_gender_transFemale": "Trans Woman",
  "one_gender_transMale": "Trans Man",
  "one_nominative_gender_female": "she",
  "one_nominative_gender_male": "he",
  "one_nominative_gender_nonBinary": "they",
  "one_possessive_gender_for_time_female": "her",
  "one_possessive_gender_for_time_male": "his",
  "one_possessive_gender_for_time_nonBinary": "their",
  "open_matches_placeholder_text": "No chats here. Try another filter to view your chats.",
  "or": "or",
  "other_exclusive_benefits": "and other exclusive benefits",
  "pass_location_verification_cta": "Pass",
  "pass_location_verification_description": "Allow location access to confirm where\nyou are and show others that your\nlocation is real.",
  "pass_location_verification_title": "Pass location verification",
  "permission_camera_prompt": "Allow access to the camera in the settings",
  "permission_microphone_prompt": "Allow access to the microphone in the settings",
  "pets_birds": "Birds",
  "pets_cats": "Cats",
  "pets_dogs": "Dogs",
  "pets_fish": "Fish",
  "pets_hamsters": "Hamsters",
  "pets_none": "None",
  "pets_rabbits": "Rabbits",
  "pets_snakes": "Snakes",
  "pets_turtles": "Turtles",
  "phone_confirm_code_resend": "We've sent you a code. You can get another one in {{seconds}} sec.",
  "phone_request_code_alert_message": "We need to make sure that {{phone}} is your number",
  "phone_request_code_alert_title": "Let’s confirm your number",
  "phone_request_code_invalid_number": "Enter a valid number",
  "phone_request_code_number_label": "Phone number",
  "phone_request_code_safety_info": "We never share your number with anyone and it won’t appear on your profile",
  "phone_request_code_subtitle": "We use phone numbers only to verify that every {{appName}} profile is real",
  "phone_request_code_title": "What’s your number?",
  "photo_dangerous_offensive_item": "Your photo may be offensive and lead to harassment.",
  "photo_dangerous_sent_title": "This photo may be unsafe. Do you want to send it?",
  "photo_removed_notification_description": "Some of your photos were removed because they don't meet our rules.",
  "photo_removed_notification_title": "Some of your photos were removed",
  "photo_sensitive_info_body": "The photo may include nudity that could affect your privacy or reputation.",
  "photo_sensitive_sent_title": "This photo may be sensitive. Do you want to send it?",
  "photo_verification": "Photo verification request",
  "photo_verification_for_action_message_error": "Your photo verification is failed. Please try again to continue.",
  "photo_verification_for_action_message_pending": "Your profile is pending photo verification. Once it's done, you'll be able to continue.",
  "photo_verification_sent_already": "Photo verification request is already sent.",
  "photo_verification_start_subtitle": "Take a selfie to confirm your identity, and show other users that you are a real person.",
  "photo_verification_start_title": "Pass photo verification",
  "photos_one": "photo",
  "photos_other": "photos",
  "price_1_months": "monthly",
  "price_1_weeks": "weekly",
  "price_3_months": "3-month",
  "price_6_months": "6-month",
  "privacy_policy": "Privacy policy",
  "private_content_description": "Screenshots aren’t allowed here.\nLet’s make sure everyone feels safe and respected.",
  "private_content_title": "Let’s keep it private",
  "profile_located_here": "{{firstName}} is located here",
  "profile_safety_tip_keep_respectful_title": "Be respectful",
  "profile_safety_tip_no_links_title": "Don’t share links",
  "profile_safety_tip_phone_number_title": "Keep your phone number private",
  "profile_safety_tip_social_handles_title": "Avoid sharing social media handles",
  "profile_safety_tips_common_label": "See profile safety tips",
  "profile_tab_label": "Profile",
  "profile_unavailable_alert_title": "This user is not available.",
  "prompts_already_covered_label": "You've got '{{category}}' covered. Why not try another category?",
  "prompts_category_cultural_challenge": "Cultural Challenge",
  "prompts_category_cultural_exploration": "Cultural Exploration",
  "prompts_category_food": "Food",
  "prompts_category_languages": "Languages",
  "prompts_category_personal": "Personal",
  "prompts_category_playful": "Playful",
  "prompts_category_relationship": "Relationship",
  "prompts_category_travel": "Travel",
  "prompts_cultural_challenge_1": "The biggest culture shock I've ever had was",
  "prompts_cultural_challenge_10": "The key to understanding another culture is",
  "prompts_cultural_challenge_2": "Dating internationally taught me that",
  "prompts_cultural_challenge_3": "A stereotype about my country that's wrong is",
  "prompts_cultural_challenge_4": "I find cultural differences fascinating because",
  "prompts_cultural_challenge_5": "The funniest misunderstanding I've had abroad was",
  "prompts_cultural_challenge_6": "Adapting to another culture taught me",
  "prompts_cultural_challenge_7": "One habit from my culture that surprises people is",
  "prompts_cultural_challenge_8": "A cultural difference I've embraced is",
  "prompts_cultural_challenge_9": "The most rewarding part of dating internationally is",
  "prompts_cultural_exploration_1": "A tradition from my country I love is",
  "prompts_cultural_exploration_2": "One surprising thing about my culture is",
  "prompts_cultural_exploration_3": "You'll impress me if you know this about my culture",
  "prompts_cultural_exploration_4": "The best way to greet someone in my culture is",
  "prompts_cultural_exploration_6": "Something I love about my hometown is",
  "prompts_cultural_exploration_7": "A unique saying from my country is",
  "prompts_cultural_exploration_8": "If I could share one thing from my culture, it’s",
  "prompts_cultural_exploration_9": "One common misunderstanding about my culture is",
  "prompts_food_1": "The dish I'll cook to win you over is",
  "prompts_food_2": "If you visit my country, try this",
  "prompts_food_3": "My favorite comfort food is",
  "prompts_food_4": "You'll win me over if you love",
  "prompts_food_5": "The best street food I've had was",
  "prompts_food_6": "The most unique dish I've tried is",
  "prompts_food_7": "I'll introduce you to my culture with this dish",
  "prompts_food_8": "Food tastes better when",
  "prompts_food_9": "My favorite food to share is",
  "prompts_holiday_label": "A holiday I never miss is",
  "prompts_languages_1": "The most romantic word in my language is",
  "prompts_languages_2": "Learning a new language is fun because",
  "prompts_languages_3": "The hardest word in my language is",
  "prompts_languages_4": "A language I'd love to learn is",
  "prompts_languages_5": "What's unique about my language?",
  "prompts_languages_6": "Love is a universal language because",
  "prompts_personal_1": "The most romantic thing someone could do for me is",
  "prompts_personal_10": "The most meaningful connections are built on",
  "prompts_personal_2": "I'll fall for you if you share my love for",
  "prompts_personal_3": "A travel memory that shaped me is",
  "prompts_personal_4": "For me, 'home' means",
  "prompts_personal_5": "The one thing I want in a partner is",
  "prompts_personal_6": "A childhood memory I treasure is",
  "prompts_personal_7": "You'll have my heart if you're passionate about",
  "prompts_personal_8": "The best way to win me over is by",
  "prompts_personal_9": "Something I value deeply is",
  "prompts_playful_1": "Our first date should include",
  "prompts_playful_10": "We'll laugh the most if we try",
  "prompts_playful_2": "We'll have fun if you teach me how to",
  "prompts_playful_3": "If I planned a surprise, it'd be",
  "prompts_playful_4": "The best music to dance to is",
  "prompts_playful_5": "I'd win you over by showing you my favorite",
  "prompts_playful_6": "Let's turn date night into an adventure by",
  "prompts_playful_7": "The most fun I've had was when I",
  "prompts_playful_8": "If I sent you a playlist, it'd start with",
  "prompts_playful_9": "Let's make our first date unforgettable with",
  "prompts_relationship_1": "In my culture, love means",
  "prompts_relationship_2": "An important value in my culture is",
  "prompts_relationship_3": "My family will love you if you",
  "prompts_relationship_4": "For me, a relationship is built on",
  "prompts_relationship_5": "A meaningful connection for me is",
  "prompts_relationship_6": "I admire a partner who values",
  "prompts_relationship_7": "The one thing I look for in a soulmate is",
  "prompts_relationship_8": "Kindness is the most attractive trait because",
  "prompts_relationship_9": "In my culture, love often looks like",
  "prompts_travel_1": "My favorite country I've visited is",
  "prompts_travel_10": "If I could visit one country, it'd be",
  "prompts_travel_2": "The one place I dream of visiting is",
  "prompts_travel_3": "You should visit my country because",
  "prompts_travel_4": "The most adventurous thing I've done abroad is",
  "prompts_travel_5": "A travel memory I'll never forget is",
  "prompts_travel_6": "My best tip for traveling smart is",
  "prompts_travel_7": "Let's plan our dream trip to",
  "prompts_travel_8": "The most breathtaking view I’ve seen was in",
  "prompts_travel_9": "My perfect travel companion is",
  "question_and_answer_contact_prompt": "If you haven't found an answer, please contact us by email: {{supportEmail}}",
  "questionnaire_after_party_review_prompt_cta_rate": "Rate",
  "questionnaire_after_party_review_prompt_info1": "It'll take a few seconds of your time and help us get more users to you.",
  "questionnaire_after_party_review_prompt_info2": "Thanks for being with us!",
  "questionnaire_after_party_review_prompt_title": "Rate {{appName}} on {{appStoreName}}",
  "questionnaire_after_party_thank_you_title": "Thanks for participating!",
  "questionnaire_prompt_notification_title": "Help {{appName}} get better. Pass a short survey.",
  "questions_list_header": "Here you can find answers which will help you",
  "questions_list_subtitle": "Please contact us if something is unclear",
  "reaction_tip_instant_chat_subtitle": "No $t(matches_one) needed — just start the conversation.",
  "reaction_tip_pass_cta": "Pass",
  "reaction_tip_pass_subtitle": "Skip {{firstName}} by pressing \"$t(reaction_tip_pass_cta)\" to go to the next profile.",
  "reaction_tip_pass_title": "Not interested?",
  "reaction_tip_smash_subtitle": "Send {{firstName}} a $t(smashes_one). If it's mutual, you will be able to start a chat.",
  "reaction_tip_smash_title": "Interested in {{firstName}}?",
  "reaction_tip_super_smash_subtitle": "Send $t(super_smashes_one) as a special symbol of sympathy! Your profile will stand out among others for {{firstName}}.",
  "reaction_tip_super_smash_title": "Really interested?",
  "reason_other": "Other",
  "record": "Record",
  "record_your_answer": "Record your answer",
  "register_step_about_subtitle": "Let other users know more about you. You can change this information at any time.",
  "register_step_about_title": "Add more about you",
  "register_step_avatars_skip_alert_subtitle": "Without 3 photos, you can't send $t(super_smashes_other), meet people, or chat.",
  "register_step_avatars_skip_alert_title": "Skip adding photos?",
  "register_step_avatars_subtitle": "You can replace photos at any time",
  "register_step_avatars_subtitle_first": "Pick a photo that shows who you are and what you love",
  "register_step_avatars_subtitle_first_v2": "Start with one photo. You can add more after.",
  "register_step_avatars_subtitle_fourth": "Add 4+ photos to see all photos on other profiles",
  "register_step_avatars_subtitle_second": "Add 2+ photos and get 64% more $t(super_smashes_other)",
  "register_step_avatars_subtitle_second_v2": "Add 3+ photos to complete your profile",
  "register_step_avatars_title_fourth": "Want to see all photos?",
  "register_step_avatars_title_second": "Want more $t(super_smashes_other)?",
  "register_step_avatars_title_second_v2": "Add more photos",
  "register_step_dob_subtitle": "Others will see only your age",
  "register_step_dob_title": "Enter your date of birth",
  "register_step_first_avatar_btn": "Select a photo",
  "register_step_first_avatar_title": "Add your first photo",
  "register_step_first_name_invalid_name": "The name field cannot contain numbers or symbols",
  "register_step_first_name_placeholder": "Enter your name here",
  "register_step_first_name_subtitle": "This name will be seen by other users",
  "register_step_first_name_title": "What is your name?",
  "register_step_gender_subtitle": "It'll help us to find people for you",
  "register_step_gender_title": "What is your gender?",
  "register_step_goal_subtitle": "You can change your goal at any time",
  "register_step_goal_title": "What is your goal?",
  "register_step_match_gender_subtitle": "You'll only see ones that you choose",
  "register_step_prompts_subtitle": "Answer prompts to give a glimpse of what it’s like to date you.",
  "register_step_prompts_subtitle_v2": "Answer prompts so people can get to know you better",
  "register_step_prompts_title": "What’s it like to date you?",
  "register_step_two_avatars_title": "Add your 2 first photos",
  "register_step_your_interests_subtitle": "Pick up to 15 things you love. It’ll help you match with people who love them too.",
  "register_step_your_interests_title": "Your Interests",
  "regularly": "Regularly",
  "religion_atheism": "Atheism",
  "religion_buddhism": "Buddhism",
  "religion_christianity": "Christianity",
  "religion_hinduism": "Hinduism",
  "religion_islam": "Islam",
  "religion_judaism": "Judaism",
  "religion_other": "Other",
  "remove": "Remove",
  "remove_boost_alert_button": "Remove",
  "remove_boost_alert_message": "If you remove $t(boosts_one), your profile will become less visible.",
  "remove_boost_alert_title": "Want to remove your $t(boosts_one)?",
  "remove_confirm_message": "Are you sure you want to remove this chat? This chat with {{firstName}} will be gone forever.",
  "remove_confirm_negative": "Cancel",
  "replace_photo": "Replace photo",
  "report": "Report",
  "report_and_close_chat": "Report and close the chat",
  "request_idfa_privacy_reference": "Read our ",
  "request_idfa_settings_reference": "You can change this option later in your phone settings",
  "request_idfa_subtitle": "We may use your activity on other apps and websites to better fit your interests.",
  "request_idfa_title": "Personalize your experience with {{appName}}",
  "request_location_verification": "Request location verification",
  "request_photo_verification": "Request photo verification",
  "restore_purchase_done_title": "All purchases has been restored",
  "restore_purchase_error_body": "Have you already made a purchase? Please try again later.",
  "restore_purchase_error_title": "Sorry, we can't access your purchase history at this time.",
  "reveal_cta_buy_single": "Reveal now – {{price}}",
  "reveal_cta_use_free": "Reveal",
  "reveal_cta_use_free_with_ads": "Watch Ad",
  "reveal_prompt_buy_reveal": "Your free Reveal has been used",
  "reveal_prompt_free_reveal": "You have a free Reveal",
  "reveal_prompt_free_reveal_with_ads": "Want a free Reveal?\nWatch a short ad.",
  "reveals_one": "reveal",
  "reveals_other": "reveals",
  "reveals_two": "$t(reveals_other)",
  "save": "Save",
  "save_changes_title": "Save changes?",
  "save_percent": "save {{save}}%",
  "search": "Search",
  "secondsAccusative_one": "$t(seconds_one)",
  "secondsAccusative_other": "$t(seconds_other)",
  "secondsGenitive_one": "$t(seconds_one)",
  "secondsGenitive_other": "$t(seconds_other)",
  "secondsInstrumental_one": "$t(seconds_one)",
  "secondsInstrumental_other": "$t(seconds_other)",
  "seconds_one": "second",
  "seconds_other": "seconds",
  "see_photo_tips_common_label": "See photo tips",
  "see_who_favorited_you_label": "See who favorited you",
  "see_who_liked_you_label": "See who liked you",
  "see_who_viewed_you_label": "See who viewed you",
  "self_location_verification_description": "To access this option, pass location verification.",
  "self_location_verification_title": "Verify your location first",
  "self_photo_verification_description": "To access this option, pass photo verification.",
  "self_photo_verification_title": "Verify your photo first",
  "send_compliment_info": "The message will be sent, even without a $t(matches_one)",
  "send_compliment_placeholder": "Say something nice...",
  "send_compliment_title": "Write a compliment to get attention faster",
  "send_request": "Send request",
  "settings": "Settings",
  "sex_orientation_asexual": "Asexual",
  "sex_orientation_bisexual": "Bisexual",
  "sex_orientation_heterosexual": "Heterosexual",
  "sex_orientation_homosexual": "Homosexual",
  "sex_orientation_omnisexual": "Omnisexual",
  "sex_orientation_pansexual": "Pansexual",
  "sex_orientation_polysexual": "Polysexual",
  "showcase_loading_error": "Error during loading showcase",
  "sign_other_options": "Other options",
  "sign_policy_agree": "See how we use your data in our",
  "sign_policy_link": "$t(privacy_policy)",
  "sign_rate_limit_alert_message": "You've already created multiple accounts this month.",
  "sign_rate_limit_alert_title": "Account limit reached",
  "sign_terms_agree": "By signing up, you agree to our",
  "sign_terms_link": "$t(terms_of_service)",
  "skip": "Skip",
  "smoking_when_drink": "When drink",
  "social_media_follow_us": "Follow us on {{socialMedia}}",
  "social_media_list_header": "Follow us to get the latest updates & tips about how to meet real people around the world",
  "social_media_other": "Other media",
  "social_media_title": "Social media",
  "social_proof_downloads_label": "downloads",
  "social_proof_reviews_label": "500k+ reviews",
  "some_time_ago": "{{count}} {{scale}} ago",
  "sometimes": "Sometimes",
  "star_sign_aquarius": "Aquarius",
  "star_sign_aries": "Aries",
  "star_sign_cancer": "Cancer",
  "star_sign_capricorn": "Capricorn",
  "star_sign_gemini": "Gemini",
  "star_sign_leo": "Leo",
  "star_sign_libra": "Libra",
  "star_sign_pisces": "Pisces",
  "star_sign_sagittarius": "Sagittarius",
  "star_sign_scorpio": "Scorpio",
  "star_sign_taurus": "Taurus",
  "star_sign_virgo": "Virgo",
  "start_instant_chat_title": "Start an Instant Chat — make the first move",
  "subscription_about_and_privacy": "About Subscription and Privacy",
  "subscription_animHeader_bottom_sent_cta": "Get more $t(super_smashes_other)",
  "subscription_benefit_title_advanced_filters": "Unlock advanced filters",
  "subscription_benefit_title_already_count": "Already {{count}}.",
  "subscription_benefit_title_compliment": "Send a personal compliment with $t(super_smashes_one)",
  "subscription_benefit_title_free_boosts_new": "Get 10x more $t(matches_other) with {{count}} $t(boosts) per week",
  "subscription_benefit_title_free_super_smashes": "Make a bold first move with {{count}} $t(super_smashes) per day",
  "subscription_benefit_title_hide_my_info": "Hide your distance and your age",
  "subscription_benefit_title_incognito": "Get seen only by users you sent $t(smashes_one)",
  "subscription_benefit_title_instant_chat": "Get unlimited Instant Chats with anyone",
  "subscription_benefit_title_read_receipt": "Find out when your messages have been seen in chat",
  "subscription_benefit_title_remove_ad": "No more advertisement",
  "subscription_benefit_title_smashes_prompt_for_subscriber": "Check who liked you",
  "subscription_benefit_title_top_quality_translator": "Chat better with a top-quality translator",
  "subscription_benefit_title_undo": "Changed your mind? Go back and view skipped profiles.",
  "subscription_benefit_title_visits_prompt_for_subscriber_anim_header": "Check who viewed you",
  "subscription_benefit_unlimited_smashes_out_subtitle": "Don't lose users. Get unlimited $t(smashes_other).",
  "subscription_benefit_unlimited_smashes_out_subtitle_with_user": "Don't lose {{firstName}}. Get unlimited $t(smashes_other).",
  "subscription_benefit_unlimited_smashes_out_title": "Out of $t(smashes_other)!",
  "subscription_benefit_unlimited_smashes_title": "Send unlimited amount of $t(smashes_other)",
  "subscription_bonus_title": "You'll get {{bonus}} in:",
  "subscription_cancel": "Cancel Subscription",
  "subscription_cancel_confirmation_message": "You can renew your subscription at any time.",
  "subscription_cancel_confirmation_title": "Are you sure you want to cancel your subscription?",
  "subscription_ended": "Your subscription ended on {{untilFormated}}.",
  "subscription_ends": "Your subscription ends on {{untilFormated}}.",
  "subscription_has_expired": "Your subscription has expired.",
  "subscription_header": "{{subscriptionName}} Subscription\n{{durationAndUnit}}",
  "subscription_if_cancel": "If you cancel now you can still access your subscription until {{untilFormated}}.",
  "subscription_legal_info_android": "By tapping “Continue”, you will be charged. Your subscription will auto-renew for the same price and package length until you cancel in Play Store settings. You agree to our",
  "subscription_legal_info_ios": "By tapping “Continue”, you will be charged and your subscription will auto-renew unless canceled via App Store settings. You agree to our",
  "subscription_price_per": "{{priceFormatted}} per {{durationAndUnit}}",
  "subscription_purchase_title": "Get {{subscriptionName}}",
  "subscription_renew": "Will renew {{untilFormated}}",
  "subscription_title": "Subscription",
  "subscription_you_canceled": "You have cancelled your subscription.",
  "super_smash_info": "Make a bold first move with $t(super_smashes_one)",
  "super_smashes_few": "$t(super_smashes_other)",
  "super_smashes_title": "$t(super_smashes_other)",
  "super_smashes_two": "$t(super_smashes_other)",
  "supported_language_am": "amharic",
  "supported_language_ar": "arabic",
  "supported_language_bg": "bulgarian",
  "supported_language_bn": "bengali",
  "supported_language_ca": "catalan",
  "supported_language_cs": "czech",
  "supported_language_cy": "welsh",
  "supported_language_da": "danish",
  "supported_language_de": "german",
  "supported_language_el": "greek",
  "supported_language_en": "english",
  "supported_language_es": "spanish",
  "supported_language_et": "estonian",
  "supported_language_eu": "basque",
  "supported_language_fa": "persian (Farsi)",
  "supported_language_fi": "finnish",
  "supported_language_fil": "filipino",
  "supported_language_fr": "french",
  "supported_language_gu": "gujarati",
  "supported_language_hi": "hindi",
  "supported_language_hr": "croatian",
  "supported_language_hu": "hungarian",
  "supported_language_id": "indonesian",
  "supported_language_is": "icelandic",
  "supported_language_it": "italian",
  "supported_language_iw": "hebrew",
  "supported_language_ja": "japanese",
  "supported_language_kn": "kannada",
  "supported_language_ko": "korean",
  "supported_language_lb": "luxembourgish",
  "supported_language_lt": "lithuanian",
  "supported_language_lv": "latvian",
  "supported_language_mk": "macedonian",
  "supported_language_ml": "malayalam",
  "supported_language_mr": "marathi",
  "supported_language_ms": "malay",
  "supported_language_nl": "dutch",
  "supported_language_no": "norwegian",
  "supported_language_pl": "polish",
  "supported_language_pt_br": "portuguese (Brazil)",
  "supported_language_pt_pt": "portuguese (Portugal)",
  "supported_language_ro": "romanian",
  "supported_language_ru": "russian",
  "supported_language_sk": "slovak",
  "supported_language_sl": "slovenian",
  "supported_language_sr": "serbian",
  "supported_language_sv": "swedish",
  "supported_language_sw": "swahili",
  "supported_language_ta": "tamil",
  "supported_language_te": "telugu",
  "supported_language_th": "thai",
  "supported_language_tr": "turkish",
  "supported_language_uk": "ukrainian",
  "supported_language_ur": "urdu",
  "supported_language_vi": "vietnamese",
  "supported_language_zh_hans": "chinese (PRC)",
  "supported_language_zh_tw": "chinese (Taiwan)",
  "take_photo_cta": "Take a photo",
  "tap_to_reveal_label": "Tap to Reveal",
  "terms": "Terms",
  "terms_of_service": "Terms of service",
  "today_only": "Today only",
  "translate_all_chats": "Translate all chats",
  "translate_cta": "Translate",
  "translate_this_chat": "Translate this chat",
  "translating": "Translating",
  "translation_description": "Automatically translate new received messages in this chat",
  "translation_language_common_title": "Translation language",
  "translation_title": "Translation",
  "translator_get_top_quality": "Do you want to get a better translation?",
  "translator_language": "Your translation language is {{lang}}",
  "translator_language_af": "Afrikaans",
  "translator_language_ak": "Akan",
  "translator_language_am": "Amharic",
  "translator_language_ar": "Arabic",
  "translator_language_as": "Assamese",
  "translator_language_ay": "Aymara",
  "translator_language_az": "Azerbaijani",
  "translator_language_be": "Belarusian",
  "translator_language_bg": "Bulgarian",
  "translator_language_bho": "Bhojpuri",
  "translator_language_bm": "Bambara",
  "translator_language_bn": "Bengali",
  "translator_language_bs": "Bosnian",
  "translator_language_ca": "Catalan",
  "translator_language_ceb": "Cebuano",
  "translator_language_ckb": "Kurdish (Sorani)",
  "translator_language_co": "Corsican",
  "translator_language_cs": "Czech",
  "translator_language_cy": "Welsh",
  "translator_language_da": "Danish",
  "translator_language_de": "German",
  "translator_language_doi": "Dogri",
  "translator_language_dv": "Dhivehi",
  "translator_language_ee": "Ewe",
  "translator_language_el": "Greek",
  "translator_language_en": "English",
  "translator_language_eo": "Esperanto",
  "translator_language_es": "Spanish",
  "translator_language_et": "Estonian",
  "translator_language_eu": "Basque",
  "translator_language_fa": "Persian",
  "translator_language_fi": "Finnish",
  "translator_language_fil": "Filipino",
  "translator_language_fr": "French",
  "translator_language_fy": "Frisian",
  "translator_language_ga": "Irish",
  "translator_language_gd": "Scottish Gaelic",
  "translator_language_gl": "Galician",
  "translator_language_gn": "Guarani",
  "translator_language_gom": "Konkani",
  "translator_language_gu": "Gujarati",
  "translator_language_ha": "Hausa",
  "translator_language_haw": "Hawaiian",
  "translator_language_he": "Hebrew",
  "translator_language_hi": "Hindi",
  "translator_language_hmn": "Hmong",
  "translator_language_hr": "Croatian",
  "translator_language_ht": "Haitian Creole",
  "translator_language_hu": "Hungarian",
  "translator_language_hy": "Armenian",
  "translator_language_id": "Indonesian",
  "translator_language_ig": "Igbo",
  "translator_language_ilo": "Iloko",
  "translator_language_is": "Icelandic",
  "translator_language_it": "Italian",
  "translator_language_ja": "Japanese",
  "translator_language_jv": "Javanese",
  "translator_language_ka": "Georgian",
  "translator_language_kk": "Kazakh",
  "translator_language_km": "Khmer",
  "translator_language_kn": "Kannada",
  "translator_language_ko": "Korean",
  "translator_language_kri": "Krio",
  "translator_language_ku": "Kurdish",
  "translator_language_ky": "Kyrgyz",
  "translator_language_la": "Latin",
  "translator_language_lb": "Luxembourgish",
  "translator_language_lg": "Luganda",
  "translator_language_ln": "Lingala",
  "translator_language_lo": "Lao",
  "translator_language_lt": "Lithuanian",
  "translator_language_lus": "Mizo",
  "translator_language_lv": "Latvian",
  "translator_language_mai": "Maithili",
  "translator_language_mg": "Malagasy",
  "translator_language_mi": "Maori",
  "translator_language_mk": "Macedonian",
  "translator_language_ml": "Malayalam",
  "translator_language_mn": "Mongolian",
  "translator_language_mni_mtei": "Meitei (Manipuri)",
  "translator_language_mr": "Marathi",
  "translator_language_ms": "Malay",
  "translator_language_mt": "Maltese",
  "translator_language_my": "Burmese",
  "translator_language_ne": "Nepali",
  "translator_language_nl": "Dutch",
  "translator_language_no": "Norwegian",
  "translator_language_nso": "Sepedi",
  "translator_language_ny": "Chichewa",
  "translator_language_om": "Oromo",
  "translator_language_or": "Odia (Oriya)",
  "translator_language_pa": "Punjabi",
  "translator_language_pl": "Polish",
  "translator_language_ps": "Pashto",
  "translator_language_pt": "Portuguese",
  "translator_language_qu": "Quechua",
  "translator_language_ro": "Romanian",
  "translator_language_ru": "Russian",
  "translator_language_rw": "Kinyarwanda",
  "translator_language_sa": "Sanskrit",
  "translator_language_sd": "Sindhi",
  "translator_language_si": "Sinhala",
  "translator_language_sk": "Slovak",
  "translator_language_sl": "Slovenian",
  "translator_language_sm": "Samoan",
  "translator_language_sn": "Shona",
  "translator_language_so": "Somali",
  "translator_language_sq": "Albanian",
  "translator_language_sr": "Serbian",
  "translator_language_st": "Sesotho",
  "translator_language_su": "Sundanese",
  "translator_language_sv": "Swedish",
  "translator_language_sw": "Swahili",
  "translator_language_ta": "Tamil",
  "translator_language_te": "Telugu",
  "translator_language_tg": "Tajik",
  "translator_language_th": "Thai",
  "translator_language_ti": "Tigrinya",
  "translator_language_tk": "Turkmen",
  "translator_language_tl": "Tagalog",
  "translator_language_tr": "Turkish",
  "translator_language_ts": "Tsonga",
  "translator_language_tt": "Tatar",
  "translator_language_ug": "Uyghur",
  "translator_language_uk": "Ukrainian",
  "translator_language_ur": "Urdu",
  "translator_language_uz": "Uzbek",
  "translator_language_vi": "Vietnamese",
  "translator_language_xh": "Xhosa",
  "translator_language_yi": "Yiddish",
  "translator_language_yo": "Yoruba",
  "translator_language_zh": "Chinese (Simplified)",
  "translator_language_zh_tw": "Chinese (Traditional)",
  "translator_language_zu": "Zulu",
  "translator_settings_description": "Automatically translate new received messages in all chats",
  "translator_settings_title": "Translator settings",
  "translator_tip_subtitle": "All messages will be translated to your preferred language. You can adjust it anytime.",
  "translator_tip_title": "Live translation is on",
  "try_again": "Try again",
  "under_maintenance_message": "Thank you for your patience!",
  "under_maintenance_subtitle": "{{appName}} is undergoing maintenance and updates. We’ll be back shortly.",
  "under_maintenance_title": "Under maintenance",
  "undo_tip_cta": "Undo",
  "undo_tip_subtitle": "Give them a second chance. Take another look at skipped profiles.",
  "undo_tip_title": "Undo your Passes",
  "unit_distance_cm": "cm",
  "unit_weight_kg": "kg",
  "unmatch_confirm_close_message": "Are you sure you want to close the chat?",
  "update_location_cta": "Update",
  "update_location_description": "If you’ve moved, please update\nyour location.",
  "update_location_title": "Update location",
  "updated_location_title": "Updated location",
  "upload_more_photos_label": "Add {{quantity}} more {{photo}} to your profile to see all photos",
  "user_banned_subtitle": "Your account has been suspended due to an issue with our terms of service{{until}}. We regret any inconvenience this may cause.\n\nPlease get in touch with customer support for assistance with Ban id: {{ban_id}}.",
  "user_banned_title": "Access restricted",
  "user_banned_until_date": "till {{date}}",
  "user_detailed_new_here": "New here",
  "user_detailed_section_local_time_title": "My time",
  "user_detailed_section_name_age_title": "My info",
  "user_detailed_section_school_title": "My education",
  "user_detailed_section_verification_label": "{{firstName}} has been photo verified",
  "user_detailed_section_verification_title": "My photo verification",
  "user_detailed_section_work_title": "My work",
  "user_detailed_sent_smash": "sent you a $t(smashes_one)",
  "user_detailed_sent_super_smash": "sent you $t(super_smashes_one)",
  "user_extended_section_from_user_title": "From user",
  "user_location_verified_on": "{{name}}'s location was verified on {{date}}",
  "user_options_block": "Block",
  "user_options_block_message": "When you block someone, you won't see this person again and they wont' see your profile - unless they've already seen your profile while swiping.",
  "user_options_block_title": "Block this person",
  "user_report_comment_cta": "Submit report",
  "user_report_details_comment_min_length": "Minimum characters: {{length}}",
  "user_report_details_header": "Could you provide more details?",
  "user_report_details_subheader": "Help our support team by sending detailed comments. Thank you!",
  "user_report_details_title": "Report details",
  "user_report_reason_feels_like_a_spam": "Feels like a spam",
  "user_report_reason_fraud": "Suspicious activity",
  "user_report_reason_inappropriate_message": "Inappropriate messages",
  "user_report_reason_inappropriate_photos": "Inappropriate photos",
  "user_share_title": "Share {{firstName}}",
  "values_beauty_art": "Beauty & Art",
  "values_career_money": "Career & Money",
  "values_entertainment_leisure": "Entertainment & Leisure",
  "values_fame_influence": "Fame & Influence",
  "values_family_kids": "Family & Kids",
  "values_science_research": "Science & Research",
  "values_self_realization": "Self Realization",
  "values_world_improvement": "World Improvement",
  "verification_common_privacy_of_photo": "This photo is only needed for verification",
  "verification_complete_subtitle": "Your photo has been uploaded successfully for verification. As soon as check will be finished you'll receive a notification.",
  "verification_complete_title": "Photo sent",
  "verification_error": "Verification error",
  "verification_process_retake": "Retake a photo",
  "verification_process_subtitle": "Make sure your pose matches the example.",
  "verification_process_title": "Does your photo match?",
  "verification_request_subtitle": "This helps us verify that it’s really you.",
  "verification_request_title": "Match the pose",
  "verification_status_done_subtitle": "Your profile has been verified so now other users will see that you are a real person.",
  "verification_status_error_subtitle": "We couldn’t verify your photo.\nMake sure your pose matches the example and try again.",
  "verification_status_error_title": "Photo verification error",
  "verification_status_pending_cta": "$t(got_it)",
  "verification_status_pending_subtitle": "Your photos are being checked. As soon as verification process is completed, you’ll be able to unblock features in the app.",
  "verification_status_pending_title": "Pending photo verification",
  "view_cta": "View",
  "view_rules": "View rules",
  "vpn_not_allowed_subtitle": "To use {{appName}}, disable VPN and try again",
  "vpn_not_allowed_title": "Access via VPN is not allowed",
  "warning": "Warning!",
  "weeksGenitive_one": "$t(weeks_one)",
  "weeksGenitive_other": "$t(weeks_other)",
  "weeksInstrumental_one": "$t(weeks_one)",
  "weeksInstrumental_other": "$t(weeks_other)",
  "weeks_one": "week",
  "weeks_other": "weeks",
  "write_prompt_answer_title": "Write your answer",
  "yearsGenitive_one": "$t(years_one)",
  "yearsGenitive_other": "$t(years_other)",
  "yearsInstrumental_one": "$t(years_one)",
  "yearsInstrumental_other": "$t(years_other)",
  "years_one": "year",
  "years_other": "years",
  "yes": "Yes",
  "your_comment_placeholder": "Your comment",
  "boosts_one": "Boost",
  "boosts_other": "Boosts",
  "matches_one": "Bump",
  "matches_other": "Bumps",
  "register_step_connections_promo": "❤️ 300k+ matches per day",
  "register_step_match_gender_unspecified": "Both",
  "sign_promo": "Find your international soulmate",
  "smashes_one": "Hello",
  "smashes_other": "Hellos",
  "super_smashes_one": "Like",
  "super_smashes_other": "Likes",
  "app_language_title": "App Language",
  "back_to_matches": "Back to matches",
  "benefits_gold_hellos_message": "Out of $t(smashes_other)!",
  "chat_unavailable": "Chat is unavailable",
  "check_location_settings_description": "Please check your location settings",
  "checkout_allowed_cards": "We currently accept {{cardBrands}} only",
  "checkout_cancel_settings": "To cancel, visit your account settings.",
  "checkout_card_number_invalid": "This card number is not valid",
  "checkout_card_number_label": "Card number",
  "checkout_card_number_required": "Please fill out card number",
  "checkout_cardholder_invalid": "This cardholder name is not valid",
  "checkout_cardholder_label": "Cardholder name",
  "checkout_cardholder_placeholder": "Name on card",
  "checkout_cardholder_required": "Please fill out cardholder name",
  "checkout_cvv_invalid": "This $t(checkout_cvv_label) is not valid",
  "checkout_cvv_label": "CVV2/CVC2",
  "checkout_cvv_required": "Please fill out a $t(checkout_cvv_label)",
  "checkout_declined_help": "The payment was declined - contact your bank's support for more information. Please try to use another card or choose another payment method.",
  "checkout_declined_title": "Payment declined.",
  "checkout_enrolling_subscription": "You are enrolling in a {{durationSubscriptionOrdinal}} subscription to https://bumpy.app service. You agree to be billed {{currency}} {{currencyFormat}} per {{durationSubscription}} until you cancel the subscription. Payments will be charged from the card you specified here. You can cancel your subscription in your settings.",
  "checkout_expiry_date_invalid": "This expiry date is not valid",
  "checkout_expiry_date_label": "Expiry date",
  "checkout_expiry_date_placeholder": "MM/YY",
  "checkout_expiry_date_required": "Please fill out an expiry date",
  "checkout_get_started_label": "Get Started",
  "checkout_not_debited": "Your account was not debited for the service.",
  "checkout_order_number": "Order number",
  "checkout_purchase_complete": "Your purchase is complete. You can view the terms of service of your purchase at",
  "checkout_secure": "Secure checkout",
  "checkout_showcase_price": "Price",
  "checkout_showcase_total": "Total",
  "checkout_showcase_vat": "VAT",
  "checkout_unpaid": "Unpaid",
  "checkout_use_supported_card": "Please use a card from one of these providers",
  "choose_express_message": "Choose express-message to start conversation",
  "choose_language": "Choose a language",
  "contact_address_title": "Registered Address:",
  "contact_email_text": "Need help? Email us at",
  "contact_intro_text": "We'd love to hear from you - and we'll get back to you soon.",
  "contact_intro_title": "Have a question, idea, or need help?",
  "contact_privacy_text": "Learn how we protect your data in our",
  "contact_success_text": "Thanks! We'll get back soon.",
  "contact_support_text": "We're here to help. Send us a message.",
  "contact_terms_text": "View our",
  "contact_us_email_placeholder": "Your email",
  "contact_us_mail_label": "E-mail*",
  "contact_us_message_label": "Message*",
  "contact_us_message_placeholder": "Your message",
  "contact_us_name_label": "Name*",
  "contact_us_name_placeholder": "Your name",
  "cookie_consent_accept_all": "Accept all",
  "cookie_consent_customize_preferences": "Customize preferences",
  "cookie_consent_customize_settings": "Customize settings",
  "cookie_consent_essential_title": "Essential",
  "cookie_consent_initial_description": "We and our partners use cookies and similar technologies to analyze website traffic, personalize offers and advertising, and enable social media features such as share buttons.",
  "cookie_consent_initial_title": "We value your privacy",
  "cookie_consent_marketing_title": "Marketing",
  "cookie_consent_preferences_description": "When you visit our website, we may store or retrieve information in your browser, primarily through cookies. This information may relate to you, your preferences, or your device. Use the options below to accept or reject cookies according to your preferences. Read our ",
  "cookie_consent_preferences_title": "Privacy Preference Center",
  "cookie_consent_reject_non_essential": "Reject non-essential",
  "cookie_consent_relevant_description": "These cookies help us show you relevant content and ads based on your interests and measure the effectiveness of our campaigns. Data may be shared with our partners.",
  "cookie_consent_save_preferences": "Save preferences",
  "cookie_consent_statistics_title": "Statistics",
  "cookie_consent_tools_necessary_description": "These cookies are essential for the website or app to function and cannot be switched off. They are usually set in response to actions you take, such as setting your privacy preferences, signing in, or filling out forms.",
  "cookie_consent_understand_description": "These cookies help us understand how visitors use the app or website so we can improve performance and the user experience. The data is anonymized.",
  "email_confirm_code_deliver_title": "We couldn’t deliver the email",
  "email_confirm_code_email_description": "The email",
  "email_confirm_code_email_label": "Update your email",
  "email_confirm_code_email_title": "Verify your email",
  "email_confirm_code_hit_message": "You’ve hit the email limit. You can try again later.",
  "email_confirm_code_incorrect_description": "looks incorrect. Update it and try again.",
  "email_confirm_code_link_description": "We'll send a link to your email to verify it's you. This helps keep everyone safe and secure.",
  "email_confirm_code_unexpected_message": "An unexpected error occurred",
  "email_confirm_code_verification_description": "We've sent a verification link to your email.",
  "email_resend": "Resend email",
  "email_spam_folder": "Didn't get it? Check your spam folder.",
  "enable_location_description": "Enable location access in your browser or site settings",
  "enable_or_download_description": "Enable location access or download our app for the best experience",
  "footer_company_title": "Company",
  "footer_cookie_policy_title": "Cookie Policy",
  "footer_copyright_text": "Copyright © {{year}} {{company}}, all rights reserved.",
  "footer_follow_us_title": "Follow us",
  "footer_legal_title": "Legal",
  "geolocation_blocked_title": "Access to geolocation is blocked",
  "geolocation_current_position_unavailable_message": "Position unavailable",
  "geolocation_not_supported_title": "Geolocation is not supported",
  "go_home_page": "Go to Home Page",
  "landing_advantage_60_users_title": "60% of users are women",
  "landing_advantage_70_users_title": "70% of users are looking for a serious relationship",
  "landing_advantage_87_users_title": "90% of users are photo-verified",
  "landing_advantage_creates_inclusive_description": "This creates an inclusive environment, increasing your chances of finding someone who matches your preferences.",
  "landing_advantage_ensure_safer_description": "We ensure a safer and more authentic experience to help you build genuine relationships.",
  "landing_advantage_join_community_description": "Join a community where the majority of members are seeking meaningful and long-lasting connections.",
  "landing_apps_download_now": "Download now",
  "landing_members_began_bump_text": "“It all began with a $t(matches_one), and from there our conversations flowed endlessly.”",
  "landing_members_forever_title": "From a $t(matches_one) to Forever",
  "landing_members_genesis_dream_text": "“Genesis really is just a dream come true for me and the person I've been looking for my entire life!”",
  "landing_members_he_brazil_text": "“He is from Brazil and I'm from Sri Lanka and we meet on {{appName}}. He cross the world for me.”",
  "landing_members_thanks_bumpy_text": "“Thanks to {{appName}}, I have found my soulmate, my forever partner.”",
  "landing_rated_found_world_title": "Designed to help you be found around the world",
  "landing_steps_connect_beyond_title": "Connect beyond language",
  "landing_steps_create_profile_title": "Create your profile",
  "landing_steps_discover_people_title": "Meet singles globally",
  "landing_steps_how_works_title": "How it works",
  "landing_steps_meaningful_conversations_description": "Start meaningful conversations with auto-translation, removing all language barriers.",
  "landing_steps_share_details_description": "Share details about yourself and add stunning photos to showcase your personality.",
  "landing_steps_start_three_description": "Get started on {{appName}} today in 3 simple steps:",
  "landing_steps_swipe_profiles_description": "Swipe through profiles of verified users worldwide to find your perfect $t(matches_one).",
  "landing_try_now_label": "Try Now",
  "last_photo_removed_file_alert": "Failed to read the file, please try again.",
  "legal_documents_continue_updated_terms": "By tapping “$t(legal_updated_cta)”, you agree to the updated  $t(terms_of_service).",
  "legal_documents_tapping_continue_confirm": "By tapping “$t(legal_updated_cta)”, you confirm you've reviewed the updated “$t(legal_updated_cta)”.",
  "legal_documents_updated_privacy_policy": "We've updated our $t(privacy_policy). Please review the document before continuing.",
  "legal_documents_updated_terms_document": "We've updated our $(terms_of_service). Please review the document before continuing.",
  "legal_documents_updated_terms_privacy": "We've updated our $(terms_of_service) and $t(privacy_policy). Please review the documents before continuing.",
  "legal_links_and": "and",
  "lets_get_started": "Hi, let's get started.",
  "load_data_failed": "Failed to load data",
  "main_cookie_preferences_text": "Cookie preferences",
  "main_tab_suggestion_browser_alert": "This browser does not support notifications.",
  "main_tab_suggestion_enabled_alert": "Notifications enabled successfully!",
  "main_tab_suggestion_home_alert": "Install the app on your home screen to enable notifications.",
  "main_tab_suggestion_notification_alert": "Your notification was automatically blocked.",
  "main_tab_suggestion_notifications_alert": "Notifications are already enabled.",
  "main_tab_suggestion_permission_alert": "Notification permission request is not supported in this browser.",
  "my_account_operations_internet_alert": "Check your internet connection and try again",
  "my_account_operations_user_alert": "User token is not available",
  "name_min_length": "Name must be at least 4 characters long",
  "no_countries_found": "No countries found",
  "no_messages_yet": "No messages yet",
  "not_detect_location_title": "Can’t detect your location",
  "notification_new_message": "You have a new message 💬",
  "notification_somebody_completed_location_verification": "Somebody has completed location verification",
  "notification_somebody_completed_photo_verification": "Somebody has completed photo verification",
  "notification_somebody_reacted_message": "Somebody reacted to your message",
  "notification_somebody_sent_location_verification": "Somebody sent location verification request",
  "notification_somebody_sent_photo_verification": "Somebody sent photo verification request",
  "oauth_create_account": "Create your account and start meeting people",
  "oauth_finish_signup": "Finish signing up",
  "page_not_found": "404 - Page Not Found",
  "payments_unlimit_payment_card_description": "Please try a different card to continue",
  "payments_unlimit_payment_card_title": "Your card is not supported",
  "payments_unlimit_payment_different_description": "Please try again or use a different payment method",
  "payments_unlimit_payment_no_title": "No internet connection",
  "payments_unlimit_payment_process_title": "We couldn't process your payment",
  "phone_confirm_code_phone_description": "We'll send a code to your phone number to verify it's you. This helps keep everyone safe and secure.",
  "phone_confirm_code_phone_title": "Verify your phone number",
  "phone_confirm_code_seconds_to": "You have used all tries, please try again in {{secondsToMinutes}}",
  "phone_confirm_code_used_tries": "You have used all tries. Please try again later.",
  "phone_request_code_invalid_message": "Invalid verification code. Please try again.",
  "phone_request_code_invalid_title": "Invalid code",
  "phone_request_code_limit_title": "Limit reached",
  "phone_request_code_many_message": "Too many verification attempts. Please try again later.",
  "phone_request_code_many_title": "Too many attempts",
  "phone_request_code_phone_message": "Invalid phone number. Please check and try again.",
  "phone_request_code_phone_title": "Invalid phone",
  "phone_request_code_verification_message": "Phone verification limit reached. Please try again later.",
  "photo_hold_drag_to_reorder": "Hold & drag to reorder",
  "photo_main": "Main",
  "photo_required_continue": "Please add at least 1 photo to continue",
  "please_try_again": "Please try again",
  "register_step_dob_correct_message": "Enter the correct date",
  "reload": "Reload",
  "request_timed_out_title": "Request timed out",
  "sign_rate_limit_email_message": "Check the email and try again",
  "sign_rate_limit_invalid_title": "Invalid email",
  "sign_rate_limit_later_message": "Please try again later",
  "sign_rate_limit_registration_alert": "Your registration details have expired. Please start again.",
  "sign_rate_limit_session_message": "Your session has expired. Please sign up again.",
  "sign_rate_limit_something_title": "Something went wrong",
  "sign_rate_limit_user_message": "User is already registered. Sign in to continue.",
  "sign_rate_limit_verified_message": "Your email has been verified",
  "something_went_wrong": "Ups, something went wrong",
  "subscription_error_alert": "Sign up error",
  "subscription_internet_connection_refresh_alert": "Check your internet connection and refresh the page.",
  "subscription_payment_method_title": "Payment method",
  "subscription_sign_error_check_alert": "Sign up error. Check your internet connection and try again",
  "subscription_something_went_wrong_alert": "Something went wrong... Please try again later",
  "subscription_thank_order_title": "Thank you for your order",
  "subscription_token_expired_alert": "Token expired",
  "subscription_vpn_settings_manually_alert": "Please open the VPN settings manually in your system",
  "turn_on_notifications_night_description": "To receive Night time notifications, allow notifications from {{appName}} in your browser settings",
  "validations_contact_us_message": "Enter your message",
  "validations_max_characters": "Max {{maxLength}} characters",
  "validations_name_required": "Enter your name",
  "verification_camera_access_error_title": "Camera Access Error",
  "verification_photo_submission_downscale_message": "Failed to downscale image for verification"
}